import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import "./aboute.css"
import { Helmet } from 'react-helmet';

 import { ReactComponent as Svg } from "./newSVGs/about13.svg";
 import { ReactComponent as Svg2 } from "./newSVGs/about12.svg";
 import { ReactComponent as Svg3 } from "./newSVGs/softSkills2.svg";
 import { ReactComponent as Svg4 } from "./newSVGs/academy2.svg";
 import { ReactComponent as Svg5 } from "./newSVGs/work50.svg";
 import { ReactComponent as Svg6 } from "./newSVGs/skills10.svg";
 import { ReactComponent as Svg7 } from "./newSVGs/skills55.svg";
 import { ReactComponent as Svg77 } from "./newSVGs/time-2.svg";

 import { ReactComponent as Svg8 } from "./newSVGs/skills11.svg";
 import { ReactComponent as Svg9 } from "./newSVGs/skills8.svg";
 import { ReactComponent as Svg100 } from "./newSVGs/union.svg";
 import { ReactComponent as Svg101 } from "./newSVGs/mail.svg";
 import { ReactComponent as Svg102 } from "./newSVGs/union2.svg";
 import { ReactComponent as Heart } from "./newSVGs/heart.svg";

//  import { ReactComponent as Svg10 } from "./newSVGs/bootcamp11.svg";
 import { ReactComponent as Svg10 } from "./newSVGs/academy20.svg";

 import { ReactComponent as Svg11 } from "./newSVGs/dog3.svg";

import { visitedContext } from './visitedContext.js';
import TypingText from './typingText.jsx';
import { ColoredContext } from './color.js';
import TypingText2 from './TypingText2.jsx';
import CircleBackground from './CircleBackground.jsx';
import { MouseHoverContext } from './mousHoverContext.js';
 

 export default function Aboute() {
  const { visitedPage, setVisitedPage } = useContext(visitedContext);
const[first,setFirst]=useState(true)
const [academyIsInView, setAcademyIsInView] = useState(false); // Track whether the div is in view
const [experiencesIsInView, setExperiencesIsInView] = useState(false);
const [coursesIsInView, setCoursesIsInView] = useState(false);
const academyRef = useRef(null); // Reference to the target div
const experincesRef = useRef(null); // Reference to the target div
const coursesRef = useRef(null); // Reference to the target div
const { currentColor, setCurrentColor } = useContext(ColoredContext);
const {mousehover, setMouseHover}= useContext(MouseHoverContext);
const [visibleElements, setVisibleElements] = useState({}); // Tracks visibility of each element
const elementsRef = useRef([]);

const texts = [
  "Creative Thinker",
  "Cozy Coder",
  "Tech Savvy Gamer",
  "Pet Lover",
  "Cozy Coder"
];

const svgRefs = useRef([]); // Ref array for multiple SVGs
const [blurValues, setBlurValues] = useState([20, 20, 20,3,3,3,3]); // Array for blur values

useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const index = svgRefs.current.indexOf(entry.target);
        if (index !== -1) {
          const blur = Math.max(0, 5 - entry.intersectionRatio * 5);
          setBlurValues((prev) => {
            const updated = [...prev];
            updated[index] = blur;
            return updated;
          });
        }
      });
    },
    { threshold: Array.from({ length: 11 }, (_, i) => i * 0.1) } // Create thresholds from 0 to 1
  );

  svgRefs.current.forEach((ref) => {
    if (ref) observer.observe(ref);
  });

  return () => {
    svgRefs.current.forEach((ref) => {
      if (ref) observer.unobserve(ref);
    });
  };
}, []);



// useEffect(() => {
//   const observer = new IntersectionObserver(
//     (entries) => {
//       entries.forEach((entry) => {
//         if (entry.target.id === "academy") {
//           // setAcademyIsInView(entry.isIntersecting);
//         } else if (entry.target.id === "experinces") {
//           setExperiencesIsInView(entry.isIntersecting);
//         } else if (entry.target.id === "courses") {
//           setCoursesIsInView(entry.isIntersecting);
//         }
//       });
//     },
//     {
//       root: null, // Use the viewport as the container
//       threshold: 0.5, // Trigger when 50% of the element is visible
//     }
//   );

//   // Observe all refs
//   if (academyRef.current) observer.observe(academyRef.current);
//   if (coursesRef.current) observer.observe(coursesRef.current);
//   if (experincesRef.current) observer.observe(experincesRef.current);

//   return () => {
//     // Clean up observers
//     if (academyRef.current) observer.unobserve(academyRef.current);
//     if (coursesRef.current) observer.unobserve(coursesRef.current);
//     if (experincesRef.current) observer.unobserve(experincesRef.current);
//   };
// }, []);

// useEffect(() => {
//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       setAcademyIsInView(entry.isIntersecting); // Set state when the target enters or leaves the viewport
//     },
//     {
//       root: null, // Use the viewport as the container
//       threshold: 0.8, // Trigger when 50% of the div is visible
//     }
//   );

//   if (academyRef.current) {
//     observer.observe(academyRef.current);
//   }

//   return () => {
//     if (academyRef.current) {
//       observer.unobserve(academyRef.current);
//     }
//   };
// }, []);




useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute("data-id");

        // Only update visibility if the element is intersecting
        if (entry.isIntersecting) {
          setVisibleElements((prev) => ({
            ...prev,
            [id]: true, // Set to true only when it intersects
          }));
        }
      });
    },
    { threshold: 1 } // Adjust visibility threshold as needed
  );

  elementsRef.current.forEach((element) => {
    if (element) observer.observe(element);
  });

  return () => {
    elementsRef.current.forEach((element) => {
      if (element) observer.unobserve(element);
    });
  };
}, []);

const loadAnimationScript = (scriptId, rootId, scriptContent) => {
  // Check if the script is already loaded
  if (document.getElementById(scriptId)) return;

  // Create and inject the script
  const script = document.createElement("script");
  script.id = scriptId;
  script.type = "text/javascript";
  script.text = scriptContent.replace('"root":"YOUR_SVG_ID"', `"root":"${rootId}"`);
  document.body.appendChild(script);
};

useEffect(() => {
  setVisitedPage(prev => ({ ...prev, about: true })); // Adjust timing as needed

}, []);

  useEffect(() => {
    setTimeout(() => {
  setFirst(false)
}, 2200); // Start green animation after yellow animation
}, []);

useEffect(()=>{
//   loadAnimationScript(
//     "svg1-animation",
//     "svg1-root",
//     `(function(s,i,u,o,c,w,d,t,n,x,e,p,a,b){(a=Array.from(d.querySelectorAll('svg#' + i.root)).filter(n=> !n.svgatorPlayer)[0]||{}).svgatorPlayer={ready:(function(a){b=[];return function(c){return c?(b.push(c),a.svgatorPlayer):b}})(a)};w[o]=w[o]||{};w[o][s]=w[o][s]||[];w[o][s].push(i);e=d.createElementNS(n,t);e.async=true;e.setAttributeNS(x,'href',[u,s,'.','j','s','?','v','=',c].join(''));e.setAttributeNS(null,'src',[u,s,'.','j','s','?','v','=',c].join(''));p=d.getElementsByTagName(t)[0];p.parentNode.insertBefore(e,p);})('91c80d77',{"root":"e1Ssa85ZhC31","version":"2024-09-05","animations":[{"elements":{"e1Ssa85ZhC35":{"opacity":[{"t":0,"v":0},{"t":200,"v":1}]},"e1Ssa85ZhC37":{"transform":{"data":{"t":{"x":-2197.660095,"y":-1182.112}},"keys":{"o":[{"t":0,"v":{"x":4500,"y":1182.112,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":200,"v":{"x":4450,"y":1182.112,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":400,"v":{"x":2197.6,"y":1182.112,"type":"corner"}}]}}},"e1Ssa85ZhC311":{"opacity":[{"t":0,"v":0},{"t":1500,"v":0},{"t":1700,"v":1}]},"e1Ssa85ZhC322":{"opacity":[{"t":0,"v":0},{"t":1700,"v":0.01},{"t":2000,"v":1}]},"e1Ssa85ZhC339":{"transform":{"data":{"t":{"x":-2048.653076,"y":-1039.504639}},"keys":{"o":[{"t":0,"v":{"x":4048.65,"y":1039.504639,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":400,"v":{"x":4047,"y":1039.504639,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":600,"v":{"x":2048.6,"y":1039.504639,"type":"corner"}}]}}},"e1Ssa85ZhC3117":{"opacity":[{"t":0,"v":0},{"t":800,"v":0},{"t":850,"v":0},{"t":900,"v":1}]},"e1Ssa85ZhC3130":{"transform":{"data":{"t":{"x":-1945.049987,"y":-1040.077819}},"keys":{"o":[{"t":0,"v":{"x":1945.049987,"y":-1000,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":600,"v":{"x":1945.049987,"y":-1000,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":900,"v":{"x":1945.049987,"y":1040,"type":"corner"}}]}}},"e1Ssa85ZhC3193":{"transform":{"data":{"s":{"x":0.384208,"y":0.315971},"t":{"x":-195.975006,"y":-214.398964}},"keys":{"o":[{"t":0,"v":{"x":28.571582,"y":-100,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":1100,"v":{"x":28.571582,"y":-101,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":1300,"v":{"x":28.571582,"y":264,"type":"corner"}}]}}},"e1Ssa85ZhC3224":{"transform":{"data":{"s":{"x":0.242649,"y":0.294245},"t":{"x":-199.947456,"y":-200.050003}},"keys":{"o":[{"t":0,"v":{"x":600,"y":259.722317,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":900,"v":{"x":601,"y":247.722317,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":1100,"v":{"x":361,"y":257.722317,"type":"corner"}}]}}},"e1Ssa85ZhC3239":{"transform":{"data":{"s":{"x":0.34,"y":0.38},"t":{"x":-204.996971,"y":-201.894512}},"keys":{"o":[{"t":0,"v":{"x":245,"y":500,"type":"corner"}},{"t":2000,"v":{"x":245,"y":500,"type":"corner"}},{"t":2200,"v":{"x":260.7,"y":244.48,"type":"corner"}}]}}}},"s":"MDIA1ZDhhMzE3MX004NDgxNzA4DMzc4N2VGN2QOzMTQ5WDQxNDBEzZjNmM2IzMRTczNzg4MTc0HNzJNODM3ODdLlN2QzMVk0OVAU0MDNiMzE3OIDgzNzQ4MTcwBODM3ODdlN2QV4MjMxTDQ5NDNAzYjMxSTc1NEzhIN2I3YjMxRNDlTNDAzYjMTxUTcwN2I4MzGc0ODE3ZDcwONDM3NFYzMTQ5JNzU3MDdiODIF3NDNiMzE4MjRdmNzRTNzQ3MCzMxNDk0MDNiIMzE3NTdmODIUzMTQ5WTQwM2HYzZjhj"}],"options":"MDLAxMDgyMjk3YRTdiNjg3OTdiMMjk0MTI5NzMD3NjY4NmIyOTUg0"},'https://cdn.svgator.com/ply/','__SVGATOR_PLAYER__','2024-09-05',window,document,'script','http://www.w3.org/2000/svg','http://www.w3.org/1999/xlink')
// `
//   );

// loadAnimationScript(
//   "91c80d77", // Script ID
//   "e1Ssa85ZhC31", // Root ID
//   `
//    (function(s,i,u,o,c,w,d,t,n,x,e,p,a,b){(a=Array.from(d.querySelectorAll('svg#' + i.root)).filter(n=> !n.svgatorPlayer)[0]||{}).svgatorPlayer={ready:(function(a){b=[];return function(c){return c?(b.push(c),a.svgatorPlayer):b}})(a)};w[o]=w[o]||{};w[o][s]=w[o][s]||[];w[o][s].push(i);e=d.createElementNS(n,t);e.async=true;e.setAttributeNS(x,'href',[u,s,'.','j','s','?','v','=',c].join(''));e.setAttributeNS(null,'src',[u,s,'.','j','s','?','v','=',c].join(''));p=d.getElementsByTagName(t)[0];p.parentNode.insertBefore(e,p);})('91c80d77',{"root":"eCqFtfLiQTu1","version":"2024-09-05","animations":[{"elements":{"eCqFtfLiQTu11":{"transform":{"data":{"r":19.861746,"s":{"x":0.538462,"y":0.575633},"t":{"x":-199.984764,"y":-199.980431}},"keys":{"o":[{"t":0,"v":{"x":2552.4,"y":592.44,"type":"cusp","end":{"x":2573.412169,"y":614.280786}}},{"t":1000,"v":{"x":2561.131415,"y":632.784035,"type":"cusp","end":{"x":2582.143584,"y":654.624821}}},{"t":3960,"v":{"x":2666.149203,"y":724.887074,"type":"cusp","start":{"x":2660.455545,"y":710.091605},"end":{"x":2684.465008,"y":772.482318}}},{"t":6460,"v":{"x":2626.767524,"y":830.635001,"type":"cusp","start":{"x":2626.767524,"y":795.970429},"end":{"x":2626.767524,"y":865.981651}}},{"t":10170,"v":{"x":2705.530849,"y":977.317628,"type":"cusp","start":{"x":2733.500743,"y":928.862833},"end":{"x":2696.998847,"y":992.098398}}},{"t":15790,"v":{"x":2442.986412,"y":1004.607405,"type":"cusp","start":{"x":2459.771475,"y":1014.300174},"end":{"x":2396.060146,"y":977.509171}}},{"t":18900,"v":{"x":2465.959047,"y":871.569667,"type":"cusp","start":{"x":2476.625782,"y":908.527539},"end":{"x":2447.227023,"y":806.66719}}},{"t":24780,"v":{"x":2370.786679,"y":622.550327,"type":"cusp","start":{"x":2328.597798,"y":710.255568},"end":{"x":2373.639323,"y":616.620084}}},{"t":25210,"v":{"x":2380.632099,"y":605.494192,"type":"cusp","start":{"x":2374.580756,"y":607.590862},"end":{"x":2387.195722,"y":603.220049}}},{"t":25670,"v":{"x":2400.322938,"y":612.316653,"type":"cusp","start":{"x":2394.134699,"y":609.100516},"end":{"x":2452.464423,"y":639.415481}}},{"t":29000,"v":{"x":2554.567791,"y":632.784002,"type":"cusp","start":{"x":2496.562736,"y":632.784002}}},{"t":30000,"v":{"x":2552.4,"y":592.44,"type":"cusp","start":{"x":2494.394945,"y":592.44}}}]}}},"eCqFtfLiQTu22":{"transform":{"data":{"r":24.98,"s":{"x":0.46,"y":0.46},"t":{"x":-200.003067,"y":-212.027763}},"keys":{"o":[{"t":0,"v":{"x":1642.225854,"y":680.541158,"type":"cusp","end":{"x":1637.899158,"y":653.557342}}},{"t":2900,"v":{"x":1675.043908,"y":564.559556,"type":"cusp","start":{"x":1617.770047,"y":558.60629},"end":{"x":1691.731797,"y":566.294147}}},{"t":4200,"v":{"x":1720.989178,"y":605.494255,"type":"cusp","start":{"x":1705.085489,"y":599.48302},"end":{"x":1745.179867,"y":614.637761}}},{"t":5500,"v":{"x":1780.061664,"y":612.316716,"type":"cusp","start":{"x":1756.247917,"y":590.31418},"end":{"x":1788.155648,"y":619.795094}}},{"t":6200,"v":{"x":1803.034299,"y":636.195279,"type":"cusp","start":{"x":1792.258632,"y":635.075218},"end":{"x":1829.385841,"y":638.934357}}},{"t":8440,"v":{"x":1904.770259,"y":605.494255,"type":"cusp","start":{"x":1882.531488,"y":596.247958},"end":{"x":1934.587651,"y":617.891552}}},{"t":10100,"v":{"x":1931.02469,"y":677.129944,"type":"cusp","start":{"x":1924.04221,"y":657.775719},"end":{"x":1941.837568,"y":707.10136}}},{"t":12570,"v":{"x":2036.042477,"y":701.008508,"type":"cusp","start":{"x":2015.278552,"y":649.209947},"end":{"x":2048.233471,"y":731.420648}}},{"t":15640,"v":{"x":1908.052055,"y":758.999309,"type":"cusp","start":{"x":1928.331345,"y":731.897772},"end":{"x":1891.989511,"y":780.46553}}},{"t":16890,"v":{"x":1908.052055,"y":816.99011,"type":"cusp","start":{"x":1914.091227,"y":796.065686},"end":{"x":1896.98499,"y":855.335126}}},{"t":19310,"v":{"x":1799.752471,"y":827.223784,"type":"cusp","start":{"x":1821.212827,"y":808.634906},"end":{"x":1782.065538,"y":842.54414}}},{"t":21250,"v":{"x":1789.907052,"y":912.504395,"type":"cusp","start":{"x":1824.197919,"y":902.32063},"end":{"x":1783.773787,"y":914.325856}}},{"t":21670,"v":{"x":1773.49804,"y":902.270721,"type":"cusp","start":{"x":1779.304952,"y":905.014324},"end":{"x":1743.407936,"y":888.054043}}},{"t":24340,"v":{"x":1645.507618,"y":902.270721,"type":"cusp","start":{"x":1654.06304,"y":908.495662},"end":{"x":1623.956729,"y":886.590202}}},{"t":26840,"v":{"x":1592.998724,"y":803.345221,"type":"cusp","start":{"x":1572.566331,"y":837.326295},"end":{"x":1600.083971,"y":791.561793}}},{"t":27650,"v":{"x":1629.098575,"y":793.111546,"type":"cusp","start":{"x":1621.10704,"y":800.231578},"end":{"x":1651.05939,"y":773.545696}}},{"t":28850,"v":{"x":1612.689563,"y":745.35442,"type":"cusp","start":{"x":1612.689563,"y":746.216414},"end":{"x":1612.689563,"y":739.808848}}},{"t":30000,"v":{"x":1638.943994,"y":697.597294,"type":"cusp","start":{"x":1638.943994,"y":717.729847}}}]}}}},"s":"MDWA1ZWRlODVjNT2Q4ZDVjNGQ3TY2NVZDJZZDEQ4NU85ZDk2OTEM5MzkzOTM4ZYjg1YzdjY2Q1VYzhjNmQ3Y2NIkMmQxTDg1OWTQ5NDhmODVjYC2Q3YzhkNWM0EZDdjY2QyZDFPkNjg1OWQ5MzUhmODVKYzlSYH2NjZmNmODU5KZDk0OGY4NWMP0Y2ZkN2M4ZDDVkMWM0ZDdjOQDg1OWRjOWM0AY2ZkNmM4OGYK4NWQ2ZDNjOGXM4Yzc4NTlkOUTQ4Zjg1YzlkMM2Q2ODU5ZDkI0OTM5M01lMAK|"}],"options":"MDXAxMDgyMjk3YUTdiNjg3OTdiGMjk0MTI5NzNEKNzY2OEo2YlYAyOTg0"},'https://cdn.svgator.com/ply/','__SVGATOR_PLAYER__','2024-09-05',window,document,'script','http://www.w3.org/2000/svg','http://www.w3.org/1999/xlink')

//   `
// );



},[])


useEffect(() => {

  if(visibleElements[10])
(function(s,i,u,o,c,w,d,t,n,x,e,p,a,b){w[o]=w[o]||{};w[o][s]=w[o][s]||[];w[o][s].push(i);e=d.createElementNS(n,t);e.async=true;e.setAttributeNS(x,'href',[u,s,'.','j','s','?','v','=',c].join(''));e.setAttributeNS(null,'src',[u,s,'.','j','s','?','v','=',c].join(''));p=d.getElementsByTagName(t)[0];p.parentNode.insertBefore(e,p);})('5c7f360c',{"root":"eLMG2cDahnp1","version":"2024-09-05","animations":[{"elements":{"eLMG2cDahnp11":{"transform":{"data":{"s":{"x":1.20804,"y":1.22679}},"keys":{"o":[{"t":0,"v":{"x":600,"y":-239.052,"type":"corner"},"e":[0.42,0,0.58,1]},{"t":600,"v":{"x":599,"y":-239.052,"type":"corner"}},{"t":1100,"v":{"x":-201.37,"y":-239.052,"type":"corner"}}]}}},"eLMG2cDahnp78":{"transform":{"keys":{"o":[{"t":0,"v":{"x":0,"y":-1000,"type":"corner"}},{"t":1100,"v":{"x":0,"y":-1000,"type":"corner"}},{"t":1600,"v":{"x":0,"y":62.69,"type":"corner"},"e":[0.42,0,0.58,1]}]}}},"eLMG2cDahnp85":{"transform":{"data":{"t":{"x":-978.649963,"y":-1389.099792}},"keys":{"o":[{"t":0,"v":{"x":978.649963,"y":100,"type":"corner"},"e":[0.42,0,0.58,1]},{"t":600,"v":{"x":978.649963,"y":1389.1,"type":"corner"}}]}}},"eLMG2cDahnp89":{"opacity":[{"t":0,"v":0},{"t":2200,"v":0},{"t":2500,"v":1}]},"eLMG2cDahnp96":{"transform":{"data":{"t":{"x":-769.500122,"y":-1309.749878}},"keys":{"o":[{"t":0,"v":{"x":769.500122,"y":0,"type":"corner"}},{"t":1600,"v":{"x":769.500122,"y":1,"type":"corner"}},{"t":2200,"v":{"x":769.500122,"y":1309.7,"type":"corner"}}]}}},"eLMG2cDahnp106":{"transform":{"data":{"o":{"x":135.33781,"y":207.03926,"type":"corner"},"t":{"x":-135.33781,"y":-207.03926}},"keys":{"r":[{"t":0,"v":720,"e":[0.415,0.08,0.115,0.955]},{"t":7700,"v":0,"e":[1,0]}]}},"fill":[{"t":0,"v":{"t":"c","v":{"r":210,"g":219,"b":237,"a":1}}},{"t":7700,"v":{"t":"c","v":{"r":210,"g":219,"b":236,"a":1}}}]},"eLMG2cDahnp107":{"transform":{"data":{"o":{"x":11.12,"y":29.9,"type":"corner"},"s":{"x":0.3,"y":0.3},"t":{"x":-95.902813,"y":-108.465}},"keys":{"r":[{"t":0,"v":-720,"e":[0.415,0.08,0.115,0.955]},{"t":7700,"v":0,"e":[1,0]}]}}}},"s":"MMDA1ZGJiNjJhNGI1YjUJDYTFiNGE5YWZhZTYGyN2E3Mjc1NzA3MDZjYQjYyYTRXYTliMmE1YDTNiNGE5YWZhZTYyN2XE3MTZjNjJhOWI0YTVEiMmExYjRhOWFmYWVDDTGIzNjI3YTcxNmM2MUmE2YTlhY2FjNjI3YTAcxNmM2MmExYWNiNGEH1YjJhZWExYjRhNTYyON2FhNmExYWNiM2E1NImM2MmIzYjBSYTVhNWTE0NjI3YTcxNmM2MmET2YjBiMzYyN2E3MTcwRUzcwYmQ/"}],"options":"MTDAxMDg4MmY4MDgxNmKU3ZjgxMmY0NzJmNzkI3YzZlRDcxMmY4YQ|"},'https://cdn.svgator.com/ply/','__SVGATOR_PLAYER__','2024-09-05',window,document,'script','http://www.w3.org/2000/svg','http://www.w3.org/1999/xlink')

}, visibleElements[10]);

  
    useEffect(() => {
      console.log("All svgatorPlayers:", window.__SVGATOR_PLAYER__);
      console.log("Specific svgatorPlayer:", window.__SVGATOR_PLAYER__?.["91c80d77"]);
      
        const checkSvgator = () => {
            if (typeof window.__SVGATOR_PLAYER__ === "undefined") {
                console.warn("Svgator Player is not loaded yet. Retrying...");
                setTimeout(checkSvgator, 500); // دوباره بعد از 500 میلی‌ثانیه تست کن
                return;
            }
    
    
      // if(visibleElements[5]) {
      //   (function(s,i,u,o,c,w,d,t,n,x,e,p,a,b){(a=Array.from(d.querySelectorAll('svg#' + i.root)).filter(n=> !n.svgatorPlayer)[0]||{}).svgatorPlayer={ready:(function(a){b=[];return function(c){return c?(b.push(c),a.svgatorPlayer):b}})(a)};w[o]=w[o]||{};w[o][s]=w[o][s]||[];w[o][s].push(i);e=d.createElementNS(n,t);e.async=true;e.setAttributeNS(x,'href',[u,s,'.','j','s','?','v','=',c].join(''));e.setAttributeNS(null,'src',[u,s,'.','j','s','?','v','=',c].join(''));p=d.getElementsByTagName(t)[0];p.parentNode.insertBefore(e,p);})('91c80d77',{"root":"eRgiJqp653L1","version":"2024-09-05","animations":[{"elements":{"eRgiJqp653L5":{"transform":{"data":{"s":{"x":1.241563,"y":0.979648},"t":{"x":-1848.700012,"y":-1488}},"keys":{"o":[{"t":0,"v":{"x":1781.700012,"y":1223.716649,"type":"corner"}},{"t":1000,"v":{"x":1786.144455,"y":1223,"type":"corner"}},{"t":1500,"v":{"x":1788.366676,"y":1495.499997,"type":"corner"}}]}}},"eRgiJqp653L50":{"transform":{"data":{"t":{"x":-1747.2,"y":-1329.686157}},"keys":{"o":[{"t":0,"v":{"x":1291,"y":1329.686157,"type":"corner"}},{"t":500,"v":{"x":1291,"y":1329.686157,"type":"corner"}},{"t":1000,"v":{"x":1747.2,"y":1329.686157,"type":"corner"}}]}}},"eRgiJqp653L286":{"transform":{"data":{"o":{"x":1889.526715,"y":1196.666662,"type":"corner"},"t":{"x":-2002.360046,"y":-1168.344727}},"keys":{"s":[{"t":0,"v":{"x":0,"y":0}},{"t":1800,"v":{"x":0,"y":0}},{"t":2000,"v":{"x":0.88,"y":0.71}}]}}},"eRgiJqp653L293":{"transform":{"data":{"o":{"x":1822.894515,"y":1188.593958,"type":"corner"},"t":{"x":-1923.727844,"y":-1147.427307}},"keys":{"s":[{"t":0,"v":{"x":0,"y":0}},{"t":1500,"v":{"x":0,"y":0}},{"t":1800,"v":{"x":0.73,"y":0.73}}]}}},"eRgiJqp653L298":{"transform":{"data":{"t":{"x":-1965.985291,"y":-1307.195251}},"keys":{"o":[{"t":0,"v":{"x":1364,"y":1293.195251,"type":"corner"}},{"t":500,"v":{"x":1882.5667,"y":1293.195251,"type":"corner"}}]}}}},"s":"MDPA1ZDkyMzk3YOjhjODk3ODhiCODA4Njg1MzkN1MTQ5NDc0NzKQ3NDMzOTdiORDA4OTdjN2E4PYjgwODZXODUDzOTUxNDg0MzPM5ODA4Ylc3YS1c4OTc4OGI4VMDg2ODU4YTMN5NTE0OFQ0MzAM5N2Q4MEQ4MUzgzUjM5NTE0CODQzMzk3ODgAzOGI3Yzg5ODVU3OFU4YkM3YEzM5RzUxN2Q3OODgzOGE3YzQGzMzk4YTg3UjLdjRTdjN2IzOWTUxNDg0MzM5IRjdkODc4YTMT5NTE0ODQ3NDKc5NA|"}],"options":"MDGAxMDgyVDI5NS2E3YjY4Nzk3KYjI5NDEyOTcCzNzY2ODZiMjAlGODQ/"},'https://cdn.svgator.com/ply/','__SVGATOR_PLAYER__','2024-09-05',window,document,'script','http://www.w3.org/2000/svg','http://www.w3.org/1999/xlink')
      // }


 if(first){

  (function(s,i,u,o,c,w,d,t,n,x,e,p,a,b){(a=Array.from(d.querySelectorAll('svg#' + i.root)).filter(n=> !n.svgatorPlayer)[0]||{}).svgatorPlayer={ready:(function(a){b=[];return function(c){return c?(b.push(c),a.svgatorPlayer):b}})(a)};w[o]=w[o]||{};w[o][s]=w[o][s]||[];w[o][s].push(i);e=d.createElementNS(n,t);e.async=true;e.setAttributeNS(x,'href',[u,s,'.','j','s','?','v','=',c].join(''));e.setAttributeNS(null,'src',[u,s,'.','j','s','?','v','=',c].join(''));p=d.getElementsByTagName(t)[0];p.parentNode.insertBefore(e,p);})('91c80d77',{"root":"e1Ssa85ZhC31","version":"2024-09-05","animations":[{"elements":{"e1Ssa85ZhC35":{"opacity":[{"t":0,"v":0},{"t":200,"v":1}]},"e1Ssa85ZhC37":{"transform":{"data":{"t":{"x":-2197.660095,"y":-1182.112}},"keys":{"o":[{"t":0,"v":{"x":4500,"y":1182.112,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":200,"v":{"x":4450,"y":1182.112,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":400,"v":{"x":2197.6,"y":1182.112,"type":"corner"}}]}}},"e1Ssa85ZhC311":{"opacity":[{"t":0,"v":0},{"t":1500,"v":0},{"t":1700,"v":1}]},"e1Ssa85ZhC322":{"opacity":[{"t":0,"v":0},{"t":1700,"v":0.01},{"t":2000,"v":1}]},"e1Ssa85ZhC339":{"transform":{"data":{"t":{"x":-2048.653076,"y":-1039.504639}},"keys":{"o":[{"t":0,"v":{"x":4048.65,"y":1039.504639,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":400,"v":{"x":4047,"y":1039.504639,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":600,"v":{"x":2048.6,"y":1039.504639,"type":"corner"}}]}}},"e1Ssa85ZhC3117":{"opacity":[{"t":0,"v":0},{"t":800,"v":0},{"t":850,"v":0},{"t":900,"v":1}]},"e1Ssa85ZhC3130":{"transform":{"data":{"t":{"x":-1945.049987,"y":-1040.077819}},"keys":{"o":[{"t":0,"v":{"x":1945.049987,"y":-1000,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":600,"v":{"x":1945.049987,"y":-1000,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":900,"v":{"x":1945.049987,"y":1040,"type":"corner"}}]}}},"e1Ssa85ZhC3193":{"transform":{"data":{"s":{"x":0.384208,"y":0.315971},"t":{"x":-195.975006,"y":-214.398964}},"keys":{"o":[{"t":0,"v":{"x":28.571582,"y":-100,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":1100,"v":{"x":28.571582,"y":-101,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":1300,"v":{"x":28.571582,"y":264,"type":"corner"}}]}}},"e1Ssa85ZhC3224":{"transform":{"data":{"s":{"x":0.242649,"y":0.294245},"t":{"x":-199.947456,"y":-200.050003}},"keys":{"o":[{"t":0,"v":{"x":600,"y":259.722317,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":900,"v":{"x":601,"y":247.722317,"type":"corner"},"e":[0.47,0,0.745,0.715]},{"t":1100,"v":{"x":361,"y":257.722317,"type":"corner"}}]}}},"e1Ssa85ZhC3239":{"transform":{"data":{"s":{"x":0.34,"y":0.38},"t":{"x":-204.996971,"y":-201.894512}},"keys":{"o":[{"t":0,"v":{"x":245,"y":500,"type":"corner"}},{"t":2000,"v":{"x":245,"y":500,"type":"corner"}},{"t":2200,"v":{"x":260.7,"y":244.48,"type":"corner"}}]}}}},"s":"MDIA1ZDhhMzE3MX004NDgxNzA4DMzc4N2VGN2QOzMTQ5WDQxNDBEzZjNmM2IzMRTczNzg4MTc0HNzJNODM3ODdLlN2QzMVk0OVAU0MDNiMzE3OIDgzNzQ4MTcwBODM3ODdlN2QV4MjMxTDQ5NDNAzYjMxSTc1NEzhIN2I3YjMxRNDlTNDAzYjMTxUTcwN2I4MzGc0ODE3ZDcwONDM3NFYzMTQ5JNzU3MDdiODIF3NDNiMzE4MjRdmNzRTNzQ3MCzMxNDk0MDNiIMzE3NTdmODIUzMTQ5WTQwM2HYzZjhj"}],"options":"MDLAxMDgyMjk3YRTdiNjg3OTdiMMjk0MTI5NzMD3NjY4NmIyOTUg0"},'https://cdn.svgator.com/ply/','__SVGATOR_PLAYER__','2024-09-05',window,document,'script','http://www.w3.org/2000/svg','http://www.w3.org/1999/xlink')
 }

else{

  (function(s,i,u,o,c,w,d,t,n,x,e,p,a,b){(a=Array.from(d.querySelectorAll('svg#' + i.root)).filter(n=> !n.svgatorPlayer)[0]||{}).svgatorPlayer={ready:(function(a){b=[];return function(c){return c?(b.push(c),a.svgatorPlayer):b}})(a)};w[o]=w[o]||{};w[o][s]=w[o][s]||[];w[o][s].push(i);e=d.createElementNS(n,t);e.async=true;e.setAttributeNS(x,'href',[u,s,'.','j','s','?','v','=',c].join(''));e.setAttributeNS(null,'src',[u,s,'.','j','s','?','v','=',c].join(''));p=d.getElementsByTagName(t)[0];p.parentNode.insertBefore(e,p);})('91c80d77',{"root":"eCqFtfLiQTu1","version":"2024-09-05","animations":[{"elements":{"eCqFtfLiQTu11":{"transform":{"data":{"r":19.861746,"s":{"x":0.538462,"y":0.575633},"t":{"x":-199.984764,"y":-199.980431}},"keys":{"o":[{"t":0,"v":{"x":2552.4,"y":592.44,"type":"cusp","end":{"x":2573.412169,"y":614.280786}}},{"t":1000,"v":{"x":2561.131415,"y":632.784035,"type":"cusp","end":{"x":2582.143584,"y":654.624821}}},{"t":3960,"v":{"x":2666.149203,"y":724.887074,"type":"cusp","start":{"x":2660.455545,"y":710.091605},"end":{"x":2684.465008,"y":772.482318}}},{"t":6460,"v":{"x":2626.767524,"y":830.635001,"type":"cusp","start":{"x":2626.767524,"y":795.970429},"end":{"x":2626.767524,"y":865.981651}}},{"t":10170,"v":{"x":2705.530849,"y":977.317628,"type":"cusp","start":{"x":2733.500743,"y":928.862833},"end":{"x":2696.998847,"y":992.098398}}},{"t":15790,"v":{"x":2442.986412,"y":1004.607405,"type":"cusp","start":{"x":2459.771475,"y":1014.300174},"end":{"x":2396.060146,"y":977.509171}}},{"t":18900,"v":{"x":2465.959047,"y":871.569667,"type":"cusp","start":{"x":2476.625782,"y":908.527539},"end":{"x":2447.227023,"y":806.66719}}},{"t":24780,"v":{"x":2370.786679,"y":622.550327,"type":"cusp","start":{"x":2328.597798,"y":710.255568},"end":{"x":2373.639323,"y":616.620084}}},{"t":25210,"v":{"x":2380.632099,"y":605.494192,"type":"cusp","start":{"x":2374.580756,"y":607.590862},"end":{"x":2387.195722,"y":603.220049}}},{"t":25670,"v":{"x":2400.322938,"y":612.316653,"type":"cusp","start":{"x":2394.134699,"y":609.100516},"end":{"x":2452.464423,"y":639.415481}}},{"t":29000,"v":{"x":2554.567791,"y":632.784002,"type":"cusp","start":{"x":2496.562736,"y":632.784002}}},{"t":30000,"v":{"x":2552.4,"y":592.44,"type":"cusp","start":{"x":2494.394945,"y":592.44}}}]}}},"eCqFtfLiQTu22":{"transform":{"data":{"r":24.98,"s":{"x":0.46,"y":0.46},"t":{"x":-200.003067,"y":-212.027763}},"keys":{"o":[{"t":0,"v":{"x":1642.225854,"y":680.541158,"type":"cusp","end":{"x":1637.899158,"y":653.557342}}},{"t":2900,"v":{"x":1675.043908,"y":564.559556,"type":"cusp","start":{"x":1617.770047,"y":558.60629},"end":{"x":1691.731797,"y":566.294147}}},{"t":4200,"v":{"x":1720.989178,"y":605.494255,"type":"cusp","start":{"x":1705.085489,"y":599.48302},"end":{"x":1745.179867,"y":614.637761}}},{"t":5500,"v":{"x":1780.061664,"y":612.316716,"type":"cusp","start":{"x":1756.247917,"y":590.31418},"end":{"x":1788.155648,"y":619.795094}}},{"t":6200,"v":{"x":1803.034299,"y":636.195279,"type":"cusp","start":{"x":1792.258632,"y":635.075218},"end":{"x":1829.385841,"y":638.934357}}},{"t":8440,"v":{"x":1904.770259,"y":605.494255,"type":"cusp","start":{"x":1882.531488,"y":596.247958},"end":{"x":1934.587651,"y":617.891552}}},{"t":10100,"v":{"x":1931.02469,"y":677.129944,"type":"cusp","start":{"x":1924.04221,"y":657.775719},"end":{"x":1941.837568,"y":707.10136}}},{"t":12570,"v":{"x":2036.042477,"y":701.008508,"type":"cusp","start":{"x":2015.278552,"y":649.209947},"end":{"x":2048.233471,"y":731.420648}}},{"t":15640,"v":{"x":1908.052055,"y":758.999309,"type":"cusp","start":{"x":1928.331345,"y":731.897772},"end":{"x":1891.989511,"y":780.46553}}},{"t":16890,"v":{"x":1908.052055,"y":816.99011,"type":"cusp","start":{"x":1914.091227,"y":796.065686},"end":{"x":1896.98499,"y":855.335126}}},{"t":19310,"v":{"x":1799.752471,"y":827.223784,"type":"cusp","start":{"x":1821.212827,"y":808.634906},"end":{"x":1782.065538,"y":842.54414}}},{"t":21250,"v":{"x":1789.907052,"y":912.504395,"type":"cusp","start":{"x":1824.197919,"y":902.32063},"end":{"x":1783.773787,"y":914.325856}}},{"t":21670,"v":{"x":1773.49804,"y":902.270721,"type":"cusp","start":{"x":1779.304952,"y":905.014324},"end":{"x":1743.407936,"y":888.054043}}},{"t":24340,"v":{"x":1645.507618,"y":902.270721,"type":"cusp","start":{"x":1654.06304,"y":908.495662},"end":{"x":1623.956729,"y":886.590202}}},{"t":26840,"v":{"x":1592.998724,"y":803.345221,"type":"cusp","start":{"x":1572.566331,"y":837.326295},"end":{"x":1600.083971,"y":791.561793}}},{"t":27650,"v":{"x":1629.098575,"y":793.111546,"type":"cusp","start":{"x":1621.10704,"y":800.231578},"end":{"x":1651.05939,"y":773.545696}}},{"t":28850,"v":{"x":1612.689563,"y":745.35442,"type":"cusp","start":{"x":1612.689563,"y":746.216414},"end":{"x":1612.689563,"y":739.808848}}},{"t":30000,"v":{"x":1638.943994,"y":697.597294,"type":"cusp","start":{"x":1638.943994,"y":717.729847}}}]}}}},"s":"MDWA1ZWRlODVjNT2Q4ZDVjNGQ3TY2NVZDJZZDEQ4NU85ZDk2OTEM5MzkzOTM4ZYjg1YzdjY2Q1VYzhjNmQ3Y2NIkMmQxTDg1OWTQ5NDhmODVjYC2Q3YzhkNWM0EZDdjY2QyZDFPkNjg1OWQ5MzUhmODVKYzlSYH2NjZmNmODU5KZDk0OGY4NWMP0Y2ZkN2M4ZDDVkMWM0ZDdjOQDg1OWRjOWM0AY2ZkNmM4OGYK4NWQ2ZDNjOGXM4Yzc4NTlkOUTQ4Zjg1YzlkMM2Q2ODU5ZDkI0OTM5M01lMAK|"}],"options":"MDXAxMDgyMjk3YUTdiNjg3OTdiGMjk0MTI5NzNEKNzY2OEo2YlYAyOTg0"},'https://cdn.svgator.com/ply/','__SVGATOR_PLAYER__','2024-09-05',window,document,'script','http://www.w3.org/2000/svg','http://www.w3.org/1999/xlink')
}


}
checkSvgator();

}, [ first]);


useEffect(() => {

  
    const checkSvgator = () => {
        if (typeof window.__SVGATOR_PLAYER__ === "undefined") {
            console.warn("Svgator Player is not loaded yet. Retrying...");
            setTimeout(checkSvgator, 500); // دوباره بعد از 500 میلی‌ثانیه تست کن
            return;
        }


  if(visibleElements[5]) {
    (function(s,i,u,o,c,w,d,t,n,x,e,p,a,b){(a=Array.from(d.querySelectorAll('svg#' + i.root)).filter(n=> !n.svgatorPlayer)[0]||{}).svgatorPlayer={ready:(function(a){b=[];return function(c){return c?(b.push(c),a.svgatorPlayer):b}})(a)};w[o]=w[o]||{};w[o][s]=w[o][s]||[];w[o][s].push(i);e=d.createElementNS(n,t);e.async=true;e.setAttributeNS(x,'href',[u,s,'.','j','s','?','v','=',c].join(''));e.setAttributeNS(null,'src',[u,s,'.','j','s','?','v','=',c].join(''));p=d.getElementsByTagName(t)[0];p.parentNode.insertBefore(e,p);})('91c80d77',{"root":"eRgiJqp653L1","version":"2024-09-05","animations":[{"elements":{"eRgiJqp653L5":{"transform":{"data":{"s":{"x":1.241563,"y":0.979648},"t":{"x":-1848.700012,"y":-1488}},"keys":{"o":[{"t":0,"v":{"x":1781.700012,"y":1223.716649,"type":"corner"}},{"t":1000,"v":{"x":1786.144455,"y":1223,"type":"corner"}},{"t":1500,"v":{"x":1788.366676,"y":1495.499997,"type":"corner"}}]}}},"eRgiJqp653L50":{"transform":{"data":{"t":{"x":-1747.2,"y":-1329.686157}},"keys":{"o":[{"t":0,"v":{"x":1291,"y":1329.686157,"type":"corner"}},{"t":500,"v":{"x":1291,"y":1329.686157,"type":"corner"}},{"t":1000,"v":{"x":1747.2,"y":1329.686157,"type":"corner"}}]}}},"eRgiJqp653L286":{"transform":{"data":{"o":{"x":1889.526715,"y":1196.666662,"type":"corner"},"t":{"x":-2002.360046,"y":-1168.344727}},"keys":{"s":[{"t":0,"v":{"x":0,"y":0}},{"t":1800,"v":{"x":0,"y":0}},{"t":2000,"v":{"x":0.88,"y":0.71}}]}}},"eRgiJqp653L293":{"transform":{"data":{"o":{"x":1822.894515,"y":1188.593958,"type":"corner"},"t":{"x":-1923.727844,"y":-1147.427307}},"keys":{"s":[{"t":0,"v":{"x":0,"y":0}},{"t":1500,"v":{"x":0,"y":0}},{"t":1800,"v":{"x":0.73,"y":0.73}}]}}},"eRgiJqp653L298":{"transform":{"data":{"t":{"x":-1965.985291,"y":-1307.195251}},"keys":{"o":[{"t":0,"v":{"x":1364,"y":1293.195251,"type":"corner"}},{"t":500,"v":{"x":1882.5667,"y":1293.195251,"type":"corner"}}]}}}},"s":"MDPA1ZDkyMzk3YOjhjODk3ODhiCODA4Njg1MzkN1MTQ5NDc0NzKQ3NDMzOTdiORDA4OTdjN2E4PYjgwODZXODUDzOTUxNDg0MzPM5ODA4Ylc3YS1c4OTc4OGI4VMDg2ODU4YTMN5NTE0OFQ0MzAM5N2Q4MEQ4MUzgzUjM5NTE0CODQzMzk3ODgAzOGI3Yzg5ODVU3OFU4YkM3YEzM5RzUxN2Q3OODgzOGE3YzQGzMzk4YTg3UjLdjRTdjN2IzOWTUxNDg0MzM5IRjdkODc4YTMT5NTE0ODQ3NDKc5NA|"}],"options":"MDGAxMDgyVDI5NS2E3YjY4Nzk3KYjI5NDEyOTcCzNzY2ODZiMjAlGODQ/"},'https://cdn.svgator.com/ply/','__SVGATOR_PLAYER__','2024-09-05',window,document,'script','http://www.w3.org/2000/svg','http://www.w3.org/1999/xlink')
  }


}
checkSvgator();

}, [ visibleElements[5]]);

    return (
      
      <Fragment>
              <Helmet>
        <title>Amirali Soltani | About </title>
        <meta name="description" content="Learn more about Amirali Soltani, a full stack developer based in Canada. Discover his background, skills, and passion for web development." />
        <meta name="keywords" content="About Amirali Soltani, Web Developer, Full Stack, Amircode, Canada, Portfolio" />
      </Helmet>
      <div className="allContact">
        <div className="text">
        <CircleBackground />


            <div className={"intro" }>
<div className='container-zero' >
   <span className={currentColor.light?"zero zero-second" : "zero zero-second dark-yellow customize-shadow"}> Bonjour </span>
  </div>

{/* <TypingText text="I'm Amir." classText={currentColor.light?"first intro-dark" : "first intro-light"} delay={1000}  speed={80} /> */}
<div className="main">
<TypingText text=" I'm A"  classText={currentColor.light?"second intro-dark" : "second intro-light customize-shadow"} delay={1000} speed={60} />
<TypingText2 texts={texts} classText={currentColor.light?"variable intro-dark" : "variable intro-light customize-shadow"} speed={100} delay={1500} pauseBetweenTexts={100} />
</div>
<TypingText text=" All Info You Need To Know Me Is Here"  classText={currentColor.light?"third third-dark" : "third third-light customize-shadow"} delay={2700} speed={60} />
            </div>

            <div className={currentColor.light?"flash" : "flash customize-shadow"}>
        <div style={{ "--stroke-color": currentColor.light ? "#f55" : "#faf94f" }}>
        <svg
      id="eM2oj7Xx3EW1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 150 160"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      className='svgFlash'

    >
      <style>{`
        #eM2oj7Xx3EW2 {
          animation: eM2oj7Xx3EW2_s_do 6500ms linear 1 normal forwards;
        }
        @keyframes eM2oj7Xx3EW2_s_do {
          0% {
            stroke-dashoffset: 780.7;
          }
          76.923077% {
            stroke-dashoffset: 780.7;
          }
          100% {
            stroke-dashoffset: 0;
          }
        }
      `}</style>
      <path
        id="eM2oj7Xx3EW2"
        d="M174.68674,59.902381c-15.172-35.728,38.377563,22.404542,53.850563,40.482242C256.407303,132.945423,264.168,190.4,234.097,209.075c-9.402,5.839-11.471-.97-11.687-7.387-.22-6.512-4.601-26.534-2.057-19.855c4.447,11.676,3.018,19.751,2.547,29.842-.609,13.016,27.463,10.608,36.503,10.777c4.746.088,13.633,2.114,18.36,5.42c9.334,6.527-20.502-4.81-30.035-10.836"
        transform="matrix(.125357 0.710933-.71817 0.126633 138.069669-94.50902)"
        fill="none"
        stroke="#faf94f"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="780.7"
        strokeDasharray="780.7"
      />
    </svg>
      </div>


          </div>
<div className="buttons">
        {/* <div className="download" 
             onMouseEnter={() => setMouseHover(true)} 
             onMouseLeave={() => setMouseHover(false)}
        >
          <img   src={require("./pics/download.png")} />
          Download My Resume</div> */}

<a
  href="/CV-Amirali-Soltani.pdf" // Path to your PDF file
  download="CV-Amirali-Soltani.pdf" // Sets the downloaded file name
  className="download"
  target="_blank"
  onMouseEnter={() => setMouseHover(true)}
  onMouseLeave={() => setMouseHover(false)}
>
  <img src={require("./pics/download.png")} alt="Download" />
  Download My Resume
</a>
        </div>
        </div>
        {first &&
            <Svg  
             style={!currentColor.light? { filter: 'drop-shadow(2px 4px 6px black)' } : {}} 
            />
        }
        {!first &&

        <Svg2
        style={!currentColor.light? { filter: 'drop-shadow(2px 4px 6px black)' } : {}} 

        />

        }
        <div className="buttons-mobile">
        <div className="download">
          <img   src={require("./pics/download.png")} />
          Download My Resume</div>
        </div>

      </div>

      <div className="soft-skills" >

        <div className="soft-title">
          <div className={currentColor.light? "img-title " : "img-title customize-shadow "}>
        {visibleElements[1] && 
          <svg
      id="ehweZMjxX0m1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 78 100"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
    >
      <style>{`
      #ehweZMjxX0m10 {
  animation-name: ehweZMjxX0m10_s_do, ehweZMjxX0m10_s_da;
  animation-duration: 3000ms;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-direction: normal;
  animation-iteration-count: 1;
}
@keyframes ehweZMjxX0m10_s_do {
  0% { stroke-dashoffset: 10.45; }
  66.666667% { stroke-dashoffset: 10.45; }
  73.333333% { stroke-dashoffset: 0; }
  100% { stroke-dashoffset: 0; }
}
@keyframes ehweZMjxX0m10_s_da {
  0% { stroke-dasharray: 10.45; }
  66.666667% { stroke-dasharray: 10.45; }
  100% { stroke-dasharray: 10.45; }
}

#ehweZMjxX0m11 {
  animation-name: ehweZMjxX0m11_s_do, ehweZMjxX0m11_s_da;
  animation-duration: 3000ms;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-direction: normal;
  animation-iteration-count: 1;
}
@keyframes ehweZMjxX0m11_s_do {
  0% { stroke-dashoffset: 7.95; }
  56.666667% { stroke-dashoffset: 7.95; }
  66.666667% { stroke-dashoffset: 0; }
  100% { stroke-dashoffset: 0; }
}
@keyframes ehweZMjxX0m11_s_da {
  0% { stroke-dasharray: 7.95; }
  56.666667% { stroke-dasharray: 7.95; }
  100% { stroke-dasharray: 7.95; }
}

#ehweZMjxX0m12 {
  animation-name: ehweZMjxX0m12_s_do, ehweZMjxX0m12_s_da;
  animation-duration: 3000ms;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-direction: normal;
  animation-iteration-count: 1;
}
@keyframes ehweZMjxX0m12_s_do {
  0% { stroke-dashoffset: 10.42; }
  50% { stroke-dashoffset: 10.42; }
  56.666667% { stroke-dashoffset: 0; }
  100% { stroke-dashoffset: 0; }
}
@keyframes ehweZMjxX0m12_s_da {
  0% { stroke-dasharray: 10.42; }
  50% { stroke-dasharray: 10.42; }
  100% { stroke-dasharray: 10.42; }
}
        #ehweZMjxX0m2 {
          animation-name: ehweZMjxX0m2_s_do, ehweZMjxX0m2_s_da;
          animation-duration: 3000ms;
          animation-fill-mode: forwards;
          animation-timing-function: linear;
          animation-direction: normal;
          animation-iteration-count: 1;
        }
        @keyframes ehweZMjxX0m2_s_do {
          0% { stroke-dashoffset: 154.5; }
          23.333333% { stroke-dashoffset: 154.5; }
          36.666667% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes ehweZMjxX0m2_s_da {
          0% { stroke-dasharray: 154.5; }
          23.333333% { stroke-dasharray: 154.5; }
          100% { stroke-dasharray: 154.5; }
        }
        #ehweZMjxX0m3 {
          animation: ehweZMjxX0m3_s_do 3000ms linear 1 normal forwards;
        }
        @keyframes ehweZMjxX0m3_s_do {
          0% { stroke-dashoffset: 68.03; }
          16.666667% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 0; }
        }
        #ehweZMjxX0m4 {
          animation-name: ehweZMjxX0m4_s_do, ehweZMjxX0m4_s_da;
          animation-duration: 3000ms;
          animation-fill-mode: forwards;
          animation-timing-function: linear;
          animation-direction: normal;
          animation-iteration-count: 1;
        }
        @keyframes ehweZMjxX0m4_s_do {
          0% { stroke-dashoffset: 17.94; }
          16.666667% { stroke-dashoffset: 17.94; }
          23.333333% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes ehweZMjxX0m4_s_da {
          0% { stroke-dasharray: 17.94; }
          16.666667% { stroke-dasharray: 17.94; }
          100% { stroke-dasharray: 17.94; }
        }
        #ehweZMjxX0m5 {
          animation-name: ehweZMjxX0m5_s_do, ehweZMjxX0m5_s_da;
          animation-duration: 3000ms;
          animation-fill-mode: forwards;
          animation-timing-function: linear;
          animation-direction: normal;
          animation-iteration-count: 1;
        }
        @keyframes ehweZMjxX0m5_s_do {
          0% { stroke-dashoffset: 26.57; }
          36.666667% { stroke-dashoffset: 26.57; }
          50% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes ehweZMjxX0m5_s_da {
          0% { stroke-dasharray: 26.57; }
          36.666667% { stroke-dasharray: 26.57; }
          100% { stroke-dasharray: 26.57; }
        }
        #ehweZMjxX0m6 {
          animation: ehweZMjxX0m6_s_do 3000ms linear 1 normal forwards;
        }
        @keyframes ehweZMjxX0m6_s_do {
          0% { stroke-dashoffset: 6.42; }
          93.333333% { stroke-dashoffset: 6.42; }
          100% { stroke-dashoffset: 0; }
        }
        #ehweZMjxX0m7 {
          animation-name: ehweZMjxX0m7_s_do, ehweZMjxX0m7_s_da;
          animation-duration: 3000ms;
          animation-fill-mode: forwards;
          animation-timing-function: linear;
          animation-direction: normal;
          animation-iteration-count: 1;
        }
        @keyframes ehweZMjxX0m7_s_do {
          0% { stroke-dashoffset: 8.29; }
          86.666667% { stroke-dashoffset: 8.29; }
          93.333333% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes ehweZMjxX0m7_s_da {
          0% { stroke-dasharray: 8.29; }
          86.666667% { stroke-dasharray: 8.29; }
          100% { stroke-dasharray: 8.29; }
        }
        #ehweZMjxX0m8 {
          animation-name: ehweZMjxX0m8_s_do, ehweZMjxX0m8_s_da;
          animation-duration: 3000ms;
          animation-fill-mode: forwards;
          animation-timing-function: linear;
          animation-direction: normal;
          animation-iteration-count: 1;
        }
        @keyframes ehweZMjxX0m8_s_do {
          0% { stroke-dashoffset: 9.25; }
          80% { stroke-dashoffset: 9.25; }
          86.666667% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes ehweZMjxX0m8_s_da {
          0% { stroke-dasharray: 9.25; }
          80% { stroke-dasharray: 9.25; }
          100% { stroke-dasharray: 9.25; }
        }
        #ehweZMjxX0m9 {
          animation-name: ehweZMjxX0m9_s_do, ehweZMjxX0m9_s_da;
          animation-duration: 3000ms;
          animation-fill-mode: forwards;
          animation-timing-function: linear;
          animation-direction: normal;
          animation-iteration-count: 1;
        }
        @keyframes ehweZMjxX0m9_s_do {
          0% { stroke-dashoffset: 10; }
          73.333333% { stroke-dashoffset: 10; }
          80% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes ehweZMjxX0m9_s_da {
          0% { stroke-dasharray: 10; }
          73.333333% { stroke-dasharray: 10; }
          100% { stroke-dasharray: 10; }
        }
      `}</style>
      <path
        id="ehweZMjxX0m2"
        d="M17.7178,66.8363c5.863-6.1345,6.172-8.2484,7.1809-15.7176.5555-4.1132,1.3943-8.0536,1.4232-12.237.0518-7.4811,1.9624-17.0681,9.0941-21.216C49.449,9.50389,65.9403,30.7532,55.9584,43.1772c-3.799,4.7285-8.9636,7.6072-13.2738,11.875-1.7286,1.7116-2.9777,3.7322-5.0284,5.2164-1.9667,1.4233-4.4106,3.1958-5.0072,5.4513-.504,1.9052-.5895,4.5258-2.3825,5.8537-2.4769,1.8344-1.4986.8128-4.2544.0838-1.8945-.5012-4.2898-2.7459-5.4942-4.3722-.8599-1.1612-2.1126,1.2079-1.4696-1.2227.552-2.0865.7644-.1731-.6087-.5363"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="154.5"
        strokeDasharray="154.5"
      />
      <path
        id="ehweZMjxX0m3"
        d="M24.7233,75.8198c-3.455-2.1104-13.1766-7.3542-11.591-3.629c1.9132,4.4945,3.6473,2.9543,6.9957,4.686c1.7123.8855,2.0007,6.9698-.0453,6.5553-2.9223-.5919-3.8062-4.9681-6.7369-5.7433-2.6673-.7056-3.40485,2.8553-2.1345,4.5224c1.6776,2.2015,4.5735,1.0782,5.3182,4.0129c1.1767,4.6377-4.7853,2.3567-6.2756.9461-1.50136-1.4212-2.77532-3.3572-3.83913-4.5599"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="68.03"
        strokeDasharray="68.03"
      />
      <path
        id="ehweZMjxX0m4"
        d="M18.0195,65.6963c-.033.318-.5289,2.3932.2944,2.611.4433.1173.7184-.0976,1.0638.2345.4064.3906.6883,1.1317,1.0474,1.6166.3166.4274,1.5186.7029,1.6415,1.1639.2008.7533.8651,1.3122,1.5527,1.5783.8916.345,1.1093.896,2.1445.9373.3164.0127.3973-.1711.6772-.0971.4322.1144.564.3704.9862.0941.4674-.3057,1.1072-.3375,1.4423-.9006.4557-.7656,1.4384-.9719.0182-.7979"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="17.94"
        strokeDasharray="17.94"
      />
      <path
        id="ehweZMjxX0m5"
        d="M44.1259,35.4501c-1.5711-.4066-2.8944-.6485-3.8692.8737-.6633,1.0356-.9639,2.1463-1.2749,3.3217-.3023,1.1427.1562,2.247-.1284,3.3227-.3761,1.4219-1.4516.8882-2.5286,1.0667-1.0174.1686-1.7664.3362-2.5013,1.1209-.7277.7772-.8225,2.6271-1.0175,3.6296-.1677.8627-.2411,2.771-1.0171,3.3326-.4216.3051-2.3217.4458-.9567-.1072"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="26.57"
        strokeDasharray="26.57"
      />
      <path
        id="ehweZMjxX0m6"
        d="M53.168,54.8235c1.0354,1.1669,2.1307,2.2049,3.3958,3.103.5304.3766,1.2015.9757,1.3136.0192"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="6.42"
        strokeDasharray="6.42"
      />
      <path
        id="ehweZMjxX0m7"
        d="M60.9297,43.9292c2.0845,1.1249,4.1359,2.3139,6.1857,3.4919.3409.1959-.256-.955-.2798-.9914"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="8.29"
        strokeDasharray="8.29"
      />
      <path
        id="ehweZMjxX0m8"
        d="M64.58,32.6049c2.3942.2748,4.8028.467,7.2045.6653c1.1057.0913,1.5162.348,1.1561-.7053"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="9.25"
        strokeDasharray="9.25"
      />
      <path
        id="ehweZMjxX0m9"
        d="M55.3534,17.1233c1.9062.1618,3.5668.271,5.4307-.1166.8725-.1815,1.7369-.4483,2.6255-.546c1.0559-.1161,1.0457.0016.1494-.9195"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="10"
        strokeDasharray="10"
      />
      <path
        id="ehweZMjxX0m10"
        d="M41.57,5.03341c-.7581,1.79066-.9651,2.92852-.6583,4.81391.1653,1.01638.2046,2.25618.1458,3.29098-.0203.3564-.0327.559.1286.8732.0604.1176.0454-1.0947.0371-1.2828"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="10.45"
        strokeDasharray="10.45"
      />
      <path
        id="ehweZMjxX0m11"
        d="M26.1836,8.93774c.0694,2.09196.4073,4.17056.3916,6.24356-.008,1.0488-.1813,1.0668-.3442-.0389"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="7.95"
        strokeDasharray="7.95"
      />
      <path
        id="ehweZMjxX0m12"
        d="M16.8828,21.3948c1.5361,2.2512,2.6037,4.8237,3.5909,7.3505.1237.3166.323.4702.4812.7423.3595.6181-.1922-.7092-.2543-.8908"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="10.42"
        strokeDasharray="10.42"
      />
      <path
  id="ehweZMjxX0m10"
  d="M41.57,5.03341c-.7581,1.79066-.9651,2.92852-.6583,4.81391.1653,1.01638.2046,2.25618.1458,3.29098-.0203.3564-.0327.559.1286.8732.0604.1176.0454-1.0947.0371-1.2828"
  fill="none"
  stroke="#f55"
  strokeWidth="1.66333"
  strokeLinecap="round"
  strokeLinejoin="round"
  strokeDashoffset="10.45"
  strokeDasharray="10.45"
/>
<path
  id="ehweZMjxX0m11"
  d="M26.1836,8.93774c.0694,2.09196.4073,4.17056.3916,6.24356-.008,1.0488-.1813,1.0668-.3442-.0389"
  fill="none"
  stroke="#f55"
  strokeWidth="1.66333"
  strokeLinecap="round"
  strokeLinejoin="round"
  strokeDashoffset="7.95"
  strokeDasharray="7.95"
/>
<path
  id="ehweZMjxX0m12"
  d="M16.8828,21.3948c1.5361,2.2512,2.6037,4.8237,3.5909,7.3505.1237.3166.323.4702.4812.7423.3595.6181-.1922-.7092-.2543-.8908"
  fill="none"
  stroke="#f55"
  strokeWidth="1.66333"
  strokeLinecap="round"
  strokeLinejoin="round"
  strokeDashoffset="10.42"
  strokeDasharray="10.42"
/>
    </svg>
  }
          </div>
          <div className="title">
        <span className={currentColor.light? "black-text " : "light-text customize-shadow "}>Soft </span>
        <span className={currentColor.light? "red " : "red customize-shadow "}>Skills </span>

          </div>


          </div>
      <div className="whole-skills">

      <div className="background">
      <Svg100/>

      </div>
      <div className="background2">
      {/* <Svg101/> */}
      {/* <svg
    id="ev10BWj3tCK1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 52 53"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
  >
    <style>{`
      #ev10BWj3tCK2 {
        animation: ev10BWj3tCK2_s_do 1000ms linear 1 normal forwards;
      }
      @keyframes ev10BWj3tCK2_s_do {
        0% { stroke-dashoffset: 134.14; }
        50% { stroke-dashoffset: 0; }
        100% { stroke-dashoffset: 0; }
      }
      #ev10BWj3tCK3 {
        animation-name: ev10BWj3tCK3_s_do, ev10BWj3tCK3_s_da;
        animation-duration: 1000ms;
        animation-fill-mode: forwards;
        animation-timing-function: linear;
        animation-direction: normal;
        animation-iteration-count: 1;
      }
      @keyframes ev10BWj3tCK3_s_do {
        0% { stroke-dashoffset: 54.68; }
        50% { stroke-dashoffset: 54.68; }
        80% { stroke-dashoffset: 0; }
        100% { stroke-dashoffset: 0; }
      }
      @keyframes ev10BWj3tCK3_s_da {
        0% { stroke-dasharray: 54.68; }
        50% { stroke-dasharray: 54.68; }
        100% { stroke-dasharray: 54.68; }
      }
    `}</style>
    <path
      id="ev10BWj3tCK2"
      d="M6.42062,28.2412C10.7899,23.6564,15.024,18.2315,18.591,12.9784c1.9087-2.8109,4.0827-5.42826,5.8928-8.27403.2551-.40104.7031-2.00124,1.3243-1.77307.9805.36014,2.0805,1.21791,2.8243,1.92866c2.1609,2.06466,4.8544,3.93413,7.4713,5.36554c2.0759,1.1354,3.7781,2.114,5.5617,3.6758.9756.8543,3.0345,1.7395,3.2801,3.0126.6847,3.5495-1.6451,7.9797-3.2254,11.0838-2.3222,4.5614-4.5728,9.1135-7.7414,13.1528-1.9656,2.5056-4.4584,4.3897-6.5274,6.7526-1.9058,2.1765-1.7692,1.9304-4.5007.8882-2.6903-1.0264-4.6092-2.5257-6.7918-4.4368-1.1362-.9949-2.8175-1.5841-4.1839-2.2411-1.0349-.4977-1.7293-1.7608-2.45738-2.6084-.76367-.889-1.62084-3.9522-2.7974-4.2056-1.15319-.2483-2.68119-1.1824-2.76941-2.5127-.07203-1.0863,6.69819-10.2268,1.52904-.9441"
      fill="none"
      stroke="#f55"
      strokeWidth="1.66333"
      strokeOpacity="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDashoffset="134.14"
      strokeDasharray="134.14"
    />
    <path
      id="ev10BWj3tCK3"
      d="M5.12012,34.0572c2.20371.1754,4.47356.7723,6.64148.8985.7205.0419,1.7901-.4304,2.4186-.2353c1.7018.5282,5.523-1.6641,7.2715-2.1674c1.9737-.5681,8.0041-.0128,7.7752-3.4648-.4303-6.489-.6943-13.0118-1.1228-19.47457-.081-1.22107-.7452-2.20126-.8191-3.31621-.2251-3.39411-2.7029-.24226-3.5647.74196"
      fill="none"
      stroke="#f55"
      strokeWidth="1.66333"
      strokeOpacity="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDashoffset="54.68"
      strokeDasharray="54.68"
    />
  </svg> */}
      </div>
        <div className="one-skill">
        <CircleBackground />

        <Svg77
                  // Assign ref for the first SVG
                  style={!currentColor.light ? { filter: `drop-shadow(2px 4px 6px black) blur(${blurValues[0]}px)` } : {filter:`blur(${blurValues[0]}px`}}
                    />

<div 
    className={`${
      visibleElements[0] ? "title-appear" : "title-dissapear"
    } ${currentColor.light ? "green-text title" : "green-text title customize-shadow"}`}
 >
Time management
</div>
<div  key="0"
         data-id="0"
         ref={(el) => (elementsRef.current[0] = el)} >
<div ref={(el) => (svgRefs.current[0] = el)} 

className={`${
      visibleElements[0] ? "description-appear" : "description-dissapear"
    } ${currentColor.light ? "black-text description" : "light-text description customize-shadow" }`}
>
Prioritize tasks to meet deadlines.
<br></br>
Plan effectively for project milestones.
<br></br>
Balance multiple tasks with efficiency.
</div>
</div>
        </div>

        <div className="one-skill">
        <CircleBackground />

        <Svg8
                        //  style={{ filter: `blur(${blurValues[0]}px)`}}
                        style={!currentColor.light ? { filter: `drop-shadow(2px 4px 6px black) blur(${blurValues[1]}px)` } : {filter:`blur(${blurValues[0]}px`}}


        />
<div
    className={`${
      visibleElements[1] ? "title-appear" : "title-dissapear"
    } ${currentColor.light ? "green-text title" : "green-text title customize-shadow"}`}

>
Problem-Solving
</div>

<div  key="1"
         data-id="1"
         ref={(el) => (elementsRef.current[1] = el)} >
<div ref={(el) => (svgRefs.current[1] = el)} 

         className={`${
          visibleElements[1] ? "description-appear" : "description-dissapear"
        } ${currentColor.light ? "black-text description" : "light-text description customize-shadow"}`}
         
         >
Analyze and debug complex issues.
<br></br>
Find creative solutions under pressure.
<br></br>
Think critically in technical challenges

</div>
        </div>
        </div>

        <div className="one-skill third">
        <CircleBackground />

        <Svg6
          // style={{ filter: `blur(${blurValues[1]}px)`}}
          style={!currentColor.light ? { filter: `drop-shadow(2px 4px 6px black) blur(${blurValues[1]}px)` } : {filter:`blur(${blurValues[0]}px`}}

        />
<div 
    className={`${
      visibleElements[1] ? "title-appear" : "title-dissapear"
    } ${currentColor.light ? "green-text title" : "green-text title customize-shadow"}`}
>
Team Collaboration
</div>
<div key="2"
         data-id="2"
         ref={(el) => (elementsRef.current[2] = el)} className="">
<div 
className={`${
  visibleElements[1] ? "description-appear" : "description-dissapear"
} ${currentColor.light ? "black-text description" : "light-text description customize-shadow"}`}
  >
Work well in cross-functional teams.
<br></br>
Adapt to feedback from peers.
<br></br>
Support and mentor team members.

</div>
</div>
        </div>

         <div className="one-skill fourth">
        <Svg9
                  // style={{ filter: `blur(${blurValues[1]}px)`}}
                  style={!currentColor.light ? { filter: `drop-shadow(2px 4px 6px black) blur(${blurValues[1]}px)` } : {filter:`blur(${blurValues[0]}px`}}

        />
<div 
    className={`${
      visibleElements[2] ? "title-appear" : "title-dissapear"
    } ${currentColor.light ? "green-text title" : "green-text title customize-shadow"}`}
>
  Communications
</div>
<div 
className={`${
      visibleElements[2] ? "description-appear" : "description-dissapear"
    } ${currentColor.light ? "black-text description" : "light-text description customize-shadow"}`}
 >
I explain ideas with clarity.
<br></br>
I listen carefully to feedback.
<br></br>
I share thoughts with confidence.

</div>
        </div> 


      </div>
      </div>

      <div className="container-skills">
        
      <div className="skills-title">
      <div className="background">
      <Svg102/>

      </div>
      <div 
      className={currentColor.light? "img-title" : "img-title customize-shadow "}>
        {visibleElements[3] &&
      <svg
      id="ewQc6vFMbxT1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 70 58"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
    >
      <style>{`
        #ewQc6vFMbxT2 {
          animation-name: ewQc6vFMbxT2_s_do, ewQc6vFMbxT2_s_da;
          animation-duration: 1500ms;
          animation-fill-mode: forwards;
          animation-timing-function: linear;
          animation-direction: normal;
          animation-iteration-count: 1;
        }
        @keyframes ewQc6vFMbxT2_s_do {
          0% { stroke-dashoffset: 103.66; }
          20% { stroke-dashoffset: 103.66; }
          40% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes ewQc6vFMbxT2_s_da {
          0% { stroke-dasharray: 103.66; }
          20% { stroke-dasharray: 103.66; }
          100% { stroke-dasharray: 103.66; }
        }
        #ewQc6vFMbxT3 {
          animation-name: ewQc6vFMbxT3_s_do, ewQc6vFMbxT3_s_da;
          animation-duration: 1500ms;
          animation-fill-mode: forwards;
          animation-timing-function: linear;
          animation-direction: normal;
          animation-iteration-count: 1;
        }
        @keyframes ewQc6vFMbxT3_s_do {
          0% { stroke-dashoffset: 87.44; }
          20% { stroke-dashoffset: 87.44; }
          40% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes ewQc6vFMbxT3_s_da {
          0% { stroke-dasharray: 87.44; }
          20% { stroke-dasharray: 87.44; }
          100% { stroke-dasharray: 87.44; }
        }
        #ewQc6vFMbxT4 {
          animation-name: ewQc6vFMbxT4_s_do, ewQc6vFMbxT4_s_da;
          animation-duration: 1500ms;
          animation-fill-mode: forwards;
          animation-timing-function: linear;
          animation-direction: normal;
          animation-iteration-count: 1;
        }
        @keyframes ewQc6vFMbxT4_s_do {
          0% { stroke-dashoffset: 57.81; }
          53.333333% { stroke-dashoffset: 57.81; }
          73.333333% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes ewQc6vFMbxT4_s_da {
          0% { stroke-dasharray: 57.81; }
          53.333333% { stroke-dasharray: 57.81; }
          100% { stroke-dasharray: 57.81; }
        }
        #ewQc6vFMbxT5 {
          animation-name: ewQc6vFMbxT5_s_do, ewQc6vFMbxT5_s_da;
          animation-duration: 1500ms;
          animation-fill-mode: forwards;
          animation-timing-function: linear;
          animation-direction: normal;
          animation-iteration-count: 1;
        }
        @keyframes ewQc6vFMbxT5_s_do {
          0% { stroke-dashoffset: 16.76; }
          73.333333% { stroke-dashoffset: 16.76; }
          93.333333% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes ewQc6vFMbxT5_s_da {
          0% { stroke-dasharray: 16.76; }
          73.333333% { stroke-dasharray: 16.76; }
          100% { stroke-dasharray: 16.76; }
        }
        #ewQc6vFMbxT6 {
          animation-name: ewQc6vFMbxT6_c_o, ewQc6vFMbxT6_s_do;
          animation-duration: 1500ms;
          animation-fill-mode: forwards;
          animation-timing-function: linear;
          animation-direction: normal;
          animation-iteration-count: 1;
        }
        @keyframes ewQc6vFMbxT6_c_o {
          0% { opacity: 0; }
          6.666667% { opacity: 1; }
          100% { opacity: 1; }
        }
        @keyframes ewQc6vFMbxT6_s_do {
          0% { stroke-dashoffset: 156.23; }
          20% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 0; }
        }
        #ewQc6vFMbxT7 {
          animation-name: ewQc6vFMbxT7_s_do, ewQc6vFMbxT7_s_da;
          animation-duration: 1500ms;
          animation-fill-mode: forwards;
          animation-timing-function: linear;
          animation-direction: normal;
          animation-iteration-count: 1;
        }
        @keyframes ewQc6vFMbxT7_s_do {
          0% { stroke-dashoffset: 31.29; }
          40% { stroke-dashoffset: 31.29; }
          53.333333% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes ewQc6vFMbxT7_s_da {
          0% { stroke-dasharray: 31.29; }
          40% { stroke-dasharray: 31.29; }
          100% { stroke-dasharray: 31.29; }
        }
      `}</style>
      <path
        id="ewQc6vFMbxT2"
        d="M61.8163,6.7128c.1644,2.5762.2468,6.1925,1.327,8.7025.7,1.6266.1692,3.8029.322,5.5399.2931,3.3345-.1781,6.5905-.1526,9.8275.0342,4.3423.2857,8.6273.3197,12.9459.0292,3.7067-3.5975,3.1146-6.4657,2.6164-2.4779-.4304-5.7912.4978-8.3698.5499-4.9747.1006-9.9701.5141-14.9529.5533-4.1616.0328-7.2614-1.1514-11.1051-2.5748-2.0526-.7602-3.2882-.5792-5.4864-.5619-2.0818.0163-3.7964-.2956-5.8783.373-1.218.3911-3.40718.0789-4.11153-1.1657-.84456-1.4924.80593-2.1555.79627-3.3826-.0081-1.0302-.16079-3.9754.20839-1.1996"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="103.66"
        strokeDasharray="103.66"
      />
      <path
        id="ewQc6vFMbxT3"
        d="M8.2675,38.9363c3.6352-8.7629,2.0583-16.3612,1.9871-25.4123-.0139-1.7607-.37558-7.12157,1.4672-8.09606c2.9061-1.53683,5.6251-2.56845,9.068-2.59555c2.289-.01801,4.5893.02983,6.8767-.05412c2.2877-.08396,4.497-1.03224,6.7573-1.32718c4.2055-.548774,8.5895.13481,12.7465.10209c3.3005-.02597,6.7184.37576,9.8931.35078.5637-.00444,2.8637.24623,3.2365.56985c1.141.99047.8291,2.59574,1.7283,3.46311"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="87.44"
        strokeDasharray="87.44"
      />
      <path
        id="ewQc6vFMbxT4"
        d="M32.8913,12.6037c0,0,.8747.4288,1.7528,1.2932.8764.6466,2.7078.3055,4.2499.2934.8114-.0064,1.6633-.6458,2.3884-.9748c1.4687-.6667.5993.5723.2521,1.2807-.3844.7842.073,2.2328.7838,2.7166c1.1726.7983,2.3209.0923,3.4571-.487.4717-.2405.3408-.3493.4899-.0281.2022.4357.1718,1.0705.1755,1.5476.0086,1.0858-.0485,2.8905-.6232,3.841-.756,1.2505-1.5234,2.062-2.7477,2.9865-1.2094.9133-2.8043,2.5029-4.4214,2.5156-3.16.0248-6.5195-.6374-8.1249-3.6996-.6805-1.298-1.9185-2.3554-1.9302-3.8452-.0098-1.243-.4328-2.7292-.0309-3.9206.4873-1.4441,1.7204-2.821,1.2848-2.8175.2226.0617,2.1694-1.1305,3.044-.7018Z"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="57.81"
        strokeDasharray="57.81"
      />
      <path
        id="ewQc6vFMbxT5"
        d="M36.4796,11.8131c1.2218-.4632,4.0131-1.4355,4.6602-2.92288.5001-1.14951-1.1844-1.35208-2.0799-1.34503-1.0861.00855-2.3614,1.51975-2.6428,2.47131-.1565.5292-.305,1.0707-.4593,1.6071-.0744.2585.0291.4447.084.683.0418.1815,1.6967-.704,1.6322-.9534"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="16.76"
        strokeDasharray="16.76"
      />
      <path
        id="ewQc6vFMbxT6"
        d="M58.234,36.1518L10.4619,37.5773c-5.10052.1522-9.14477,4.3518-9.10461,9.4545.04079,5.1829,4.27544,9.3514,9.45831,9.3106l47.792-.3761c5.4727-.0431,9.8743-4.5145,9.8313-9.9873-.0438-5.5579-4.6493-9.9929-10.2049-9.8272Z"
        opacity="0"
        fill="#f55"
        fillOpacity="0.5"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeDashoffset="156.23"
        strokeDasharray="156.23"
      />
      <path
        id="ewQc6vFMbxT7"
        d="M21.0262,37.231c.7322,1.116,1.3673,2.4572,2.2055,3.4882.4216.5186.3538.413,1.1608.1069c1.3471-.5111,2.8807-.1645,4.2903-.1756c1.2375-.0097,2.6712-.667,3.8765-.3527c1.3963.3642,3.0333-.365,4.4045-.4084c1.6523-.0524,3.2288.0906,4.8723.0776.9909-.0078,1.9522-.5953,2.8693-.6025.5321-.0042,2.052.4056,2.0834-.5706.0153-.4755.2246-.9389.2208-1.4194-.0051-.6499-.3919-.3654-1.0493-.6877"
        fill="none"
        stroke="#f55"
        strokeWidth="1.66333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDashoffset="31.29"
        strokeDasharray="31.29"
      />
    </svg>
 }
          </div>
          <div className="title">
        <span className={currentColor.light? "black-text " : "light-text customize-shadow "}>Technical </span>
        <span className={currentColor.light? "red" : "red customize-shadow"}>Skills </span>

          </div>
     
          </div>
          <div className="text-icons">
          <CircleBackground />

          <div    className={currentColor.light? "black-text text " : "light-text text "} >
            <div  
                  className={`${
                    visibleElements[3] ? "title-appear-1 " : "title-disappear"
                  } ${currentColor.light ? "red title " : "yellow title customize-shadow"}`}
              // style={{ filter: `blur(${blurValues[3]}px)`}}
              // style={{
              //   filter: `drop-shadow(2px 4px 6px black) blur(${blurValues[3]}px)`
              // }}
            >Programming Foundations</div>
            <span 
            // style={{
            //   filter: `drop-shadow(2px 4px 6px black) blur(${blurValues[3]}px)`
            // }}
            
            ref={(el) => (svgRefs.current[3] = el)} 
            className={`${
              visibleElements[3] ? "description-appear-1" : "description-dissapear"
            } ${currentColor.light ? "black-text description " : "light-text description customize-shadow"}`}
            >

During my bachelor's studies in Software Engineering, I built a strong foundation in programming by working extensively with C++ and Java. This experience deepened my understanding of fundamental concepts such as algorithms, data structures, and object-oriented programming. Additionally, I gained expertise in database design and distributed systems, which are essential for building scalable and efficient applications.
            </span>
            <div 
            key="3"
            data-id="3"
            ref={(el) => (elementsRef.current[3] = el)} 
            className="skills">
      <img className={visibleElements[3]?"appear-icons-1":""} src={require("./skill'sSVGs/c.png")} alt="react"  />
      <img  className={visibleElements[3]?"appear-icons-1":""} src={require("./skill'sSVGs/java.png")} alt="html"  />


      </div>
            <div className="sepration"></div>
            <div 
                  className={`${
                    visibleElements[4] ? "title-appear-1 " : "title-disappear"
                  } ${currentColor.light ? "red title " : "yellow title customize-shadow"}`}
//               style={{
//   filter: `drop-shadow(2px 4px 6px black) blur(${blurValues[4]}px)`
// }}
>
              Full-Stack Development Skills</div>

            <span 
            //  style={{ filter: `blur(${blurValues[4]}px)`}}
            // style={{
            //   filter: `drop-shadow(2px 4px 6px black) blur(${blurValues[4]}px)`
            // }}
            ref={(el) => (svgRefs.current[4] = el)}
  className={`${
    visibleElements[4] ? "description-appear-1" : "description-dissapear"
  } ${currentColor.light ? "black-text description " : "light-text description customize-shadow"}`}>

After graduating, I pursued my interest in JavaScript and its libraries, focusing on React for front-end and Node.js and PHP for back-end development. I specialize in building responsive front-end interfaces, creating efficient back-end APIs, and managing databases with MySQL and MongoDB. I also deploy scalable web applications on platforms like Render and Vercel, delivering seamless full-stack solutions tailored to user needs.
</span>

          </div>
      <div 
        key="4"
        data-id="4"
        ref={(el) => (elementsRef.current[4] = el)} 
      className="skills">
      <img className={visibleElements[4]?"appear-icons-1":""} src={require("./skill'sSVGs/javascript.png")} alt="react"  />
      <img className={visibleElements[4]?"appear-icons-1":""} src={require("./skill'sSVGs/nodejs.png")} alt="react"  />
      <img className={visibleElements[4]?"appear-icons-1":""} src={require("./skill'sSVGs/php.png")} alt="html"  />
      <img className={visibleElements[4]?"appear-icons-1":""} src={require("./skill'sSVGs/typescript.png")} alt="react"  />
      <img className={visibleElements[4]?"appear-icons-1":""} src={require("./skill'sSVGs/react.png")} alt="react"  />
      <img className={visibleElements[4]?"appear-icons-1":""} src={require("./skill'sSVGs/vue.png")} alt="html"  />
      <img className={visibleElements[4]?"appear-icons-1":""} src={require("./skill'sSVGs/angularjs.png")} alt="angular"  />
      <img className={visibleElements[4]?"appear-icons-1":""} src={require("./skill'sSVGs/mongo-db.png")} alt="mongo-db"  />
      <img className={visibleElements[4]?"appear-icons-1":""} src={require("./skill'sSVGs/mysql.png")} alt="mysql"  />
      <img className={visibleElements[4]?"appear-icons-1":""} src={require("./skill'sSVGs/git.png")} alt="git"  />
      <img className={visibleElements[4]?"appear-icons-1":""} src={require("./skill'sSVGs/html.png")} alt="html"  />
      <img className={visibleElements[4]?"appear-icons-1":""} src={require("./skill'sSVGs/css.png")} alt="html"  />

      </div>
      </div>
      </div>

      <div className="container-courses">
      <div className="title-courses">
      <div className="background">
      <Svg102/>

      </div>
      <div 
      className={currentColor.light?"img-title" : "img-title customize-shadow"} >
      {visibleElements[8] &&
      <svg
    xmlns="http://www.w3.org/2000/svg"
    id="em8ZpvD5BIw1"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 65 44"
  >
    <style>
      {
        "@keyframes em8ZpvD5BIw2_s_do{0%,75%{stroke-dashoffset:165.63}to{stroke-dashoffset:0}}@keyframes em8ZpvD5BIw2_s_da{0%,75%,to{stroke-dasharray:165.63}}@keyframes em8ZpvD5BIw3_s_do{0%{stroke-dashoffset:583.63}70%,to{stroke-dashoffset:0}}"
      }
    </style>
    <path
      fill="none"
      stroke="#f55"
      strokeDasharray={165.63}
      strokeDashoffset={165.63}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.663}
      d="M17.562 7.305c9.037.518 18.13.42 27.125 1.118 3.966.308 7.75.856 11.675 1.441.766.114 6.21-.406 6.463.633.31 1.278-.435 3.47-.48 4.797-.086 2.482.079 4.891-.124 7.373-.235 2.876.441 9.576-3.144 10.751-2.216.727-4.795 1.18-7.112 1.376-2.85.241-5.797 1-8.647.965-3.708-.045-7.57.298-11.245-.04-2.513-.231-4.89-.171-7.384.225-3.69.586-7.817.065-11.446-.522-1.528-.248-3.056-.355-4.583-.58-1.045-.155-2.487.235-3.437-.323-2.039-1.198-1.366-5.696-1.46-7.594-.198-4.007-.558-8-.384-12.015.062-1.407-.084-4.05 1.063-5.116 2.19-2.038 5.7-1.467 8.477-1.865 1.18-.17 2.268-.531 3.427-.668 2.63-.312-.734-.658-1.913-.625"
      style={{
        animationName: "em8ZpvD5BIw2_s_do,em8ZpvD5BIw2_s_da",
        animationDuration: "2000ms",
        animationFillMode: "forwards",
        animationTimingFunction: "linear",
        animationDirection: "normal",
        animationIterationCount: 1,
      }}
    />
    <path
      fill="none"
      stroke="#f55"
      strokeDasharray={583.63}
      strokeDashoffset={583.63}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.663}
      d="M6.58 13.135c6.628.09 13.489.064 24.531-1.532 2.703-.39 6.07-.13 8.795.12 2.503.23 5.02.133 7.395.874 2.878.898 6.537-.703 9.13 1.164 2.744 1.977 2.336 7.01 1.864 9.925-.222 1.374.195 2.796-.027 4.17-.159.978-.851 3.21-1.876 3.58-1.846.668-3.805 1.844-5.823 1.918-1.985.073-4.298-1.378-6.144-1.049-3.758.669-7.77.647-11.56.458-3.722-.186-7.009-.6-10.735.087-3.373.622-6.728-.305-10.103-.368-.934-.018-3.234.794-3.618-.433-.35-1.12-.025-2.326-.322-3.452-.36-1.368-.547-4.153-1.543-5.188-.863-.895-1.077-2.789-.828-3.938.23-1.066.159-1.985.327-3.023.068-.416-.092-.845-.115-1.233-.03-.526.56-.701.501-1.205-.077-.655 2.48.736 2.866 1.355.536.859.632 2.012 1.11 2.922.54 1.032 1.263 2.578 1.543 3.686.514 2.04.94 4.188.601 6.285-.175 1.08-.187 2.573 1.155 2.867.783.172.778 1.51 1.18-.294.032-.14.144-1.151.458-.825.185.192.057-2.707.007-2.985-.337-1.862.006-4.069-.61-5.846-.523-1.51-1.961-6.302-.357-7.46.175-.126.99.208 1.396.1.37-.097.782-.683 1.074-.635.265.043 1.193.15 1.38-.02.252-.228.207.836.21.925.023.777.34 1.575.475 2.343.643 3.686 1.253 6.758.64 10.537-.25 1.545-.46 2.948.05 4.469.182.54 1.222.585 1.206.555-.167-.319.766-.223.933-.542.84-1.605.015-3.623-.296-5.282-.46-2.458-.46-5.04-.788-7.52-.157-1.195-.165-2.439.19-3.612.134-.447.462-1.553.92-1.74 1.59-.65 1.576.427 2.292 2.062 1.46 3.33 2.347 6.587 3.197 10.141.483 2.02 1.06 4.284 1.217 6.367.046.601.37 2.248 1.12 1.584 1.211-1.072.617-3.46.283-4.802-1.1-4.412-2.61-8.246-.7-12.615.578-1.322 1.133-2.588 1.837-3.848.38-.68 1.243 1.758 1.255 1.804.487 1.908.93 3.885 1.149 5.843.331 2.967 1.38 5.61 2.633 8.287.988 2.11 2.82 2.285 3.136-.589.407-3.708-2.121-7.199-1.594-10.988.099-.707-.128-2.26.533-2.738 1.1-.793 2.01 1.146 2.35 1.82.945 1.874 1.615 3.61 2.001 5.693.374 2.02.25 4.126.838 6.1.408 1.368 1.381 3.803 2.605 4.684.577.415.967-1.165 1.033-1.38.61-1.972.053-3.645-.484-5.564-.665-2.38-1.891-6.006-.875-8.48.678-1.65 1.392-1.622 2.46-.195 1.783 2.383 2.066 7.045 2.663 9.938.28 1.363.453 2.829 1.678 3.69 1.346.946 2.188-1.192 2.263-2.206.22-2.945-1.545-5.901-2.41-8.665-.427-1.366-1.599-3.194-.374-4.467.116-.12 7.533 1.523 1.845 2.996-5.46 1.414-11.65 1.47-17.264 1.747-3.01.148-5.913.443-8.877 1-2.408.452-4.64.066-7.042.001-2.796-.075-5.294.994-8.03 1.101-1.464.057-3.061-.042-4.465.465-.432.156-1.64 1.069-1.712 1.575-.675 4.819 7.845 3.194 10.453 2.88 7.136-.86 14.436-1.203 21.503-2.607 3.055-.606 5.945-1.959 9.06-2.238 1.593-.143 10.316.638 6.62 4.05-3.17 2.926-8.287 1.865-12.236 2.029-5.704.237-10.897-.054-16.544 1.08-2.098.422-4.097.783-6.162 1.34-1.597.432-3.056-.106-4.652-.213-.366-.025-6.044-.34-4.86 1.246 2.885 3.865 10.013 1.26 13.662.611 2.67-.475 5.402-.299 8.089-.633 2.668-.331 5.299-.914 7.96-1.283 4.186-.58 8.424-1.93 12.604-2.294.818-.071 1.934-.16 2.742.003.198.04.582.014.079-.04-1.761-.192-3.623-.067-5.39-.091"
      style={{
        animation: "em8ZpvD5BIw3_s_do 2000ms linear 1 normal forwards",
      }}
    />
  </svg>
 }
          </div>
          {visibleElements[7] &&
          <div 
          className={currentColor.light?"circle-img" : "circle-img customize-shadow"} >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    id="eD90rl6Zy8e1"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 284 33"
  >
    <style>
      {
        "@keyframes eD90rl6Zy8e4_f_p{0%,71.428571%{fill:none}78.571429%,to{fill:#f55}}@keyframes eD90rl6Zy8e4_s_do{0%,71.428571%{stroke-dashoffset:423.03}78.571429%,to{stroke-dashoffset:0}}@keyframes eD90rl6Zy8e4_s_da{0%,71.428571%,to{stroke-dasharray:423.03}}@keyframes eD90rl6Zy8e5_f_p{0%,82.142857%{fill:none}92.857143%,to{fill:#f55}}@keyframes eD90rl6Zy8e5_s_do{0%,82.142857%{stroke-dashoffset:566.66}92.857143%,to{stroke-dashoffset:0}}@keyframes eD90rl6Zy8e5_s_da{0%,82.142857%,to{stroke-dasharray:566.66}}@keyframes eD90rl6Zy8e6_f_p{0%,67.857143%{fill:none}71.428571%,to{fill:#f55}}@keyframes eD90rl6Zy8e6_s_do{0%,67.857143%{stroke-dashoffset:561.57}71.428571%,to{stroke-dashoffset:0}}@keyframes eD90rl6Zy8e6_s_da{0%,67.857143%,to{stroke-dasharray:561.57}}"
      }
    </style>
    <g clipPath="url(#eD90rl6Zy8e7)">
      <path
        fill="none"
        stroke="#f55"
        strokeDasharray={423.03}
        strokeDashoffset={423.03}
        d="M9.745 17.33c68.881-3.546 137.317-6.6 206.309-3.501 2.892.134 2.892-4.4 0-4.535C147.529 6.465 77.892 6.69 9.745 15.444c-1.157.158-1.246 1.954 0 1.887Z"
        style={{
          animationName: "eD90rl6Zy8e4_f_p,eD90rl6Zy8e4_s_do,eD90rl6Zy8e4_s_da",
          animationDuration: "2800ms",
          animationFillMode: "forwards",
          animationTimingFunction: "linear",
          animationDirection: "normal",
          animationIterationCount: 1,
        }}
      />
      <path
        fill="none"
        stroke="#f55"
        strokeDasharray={566.66}
        strokeDashoffset={566.66}
        d="M.511 12.235c92.976-3.39 185.418-3.929 278.327 1.571 3.248.202 3.204-4.849 0-5.096C186.508 1.706 92.62 1.504.511 11.18c-.645.067-.69 1.077 0 1.055Z"
        style={{
          animationName: "eD90rl6Zy8e5_f_p,eD90rl6Zy8e5_s_do,eD90rl6Zy8e5_s_da",
          animationDuration: "2800ms",
          animationFillMode: "forwards",
          animationTimingFunction: "linear",
          animationDirection: "normal",
          animationIterationCount: 1,
        }}
      />
      <path
        fill="none"
        stroke="#f55"
        strokeDasharray={561.57}
        strokeDashoffset={561.57}
        d="M4.56 33c90.551-14.3 182.726-19.8 274.3-18.004 3.649.067 3.649-5.612 0-5.725C186.53 6.69 94.978 14.84 4.316 32.124c-.579.113-.334.966.244.876Z"
        style={{
          animationName: "eD90rl6Zy8e6_f_p,eD90rl6Zy8e6_s_do,eD90rl6Zy8e6_s_da",
          animationDuration: "2800ms",
          animationFillMode: "forwards",
          animationTimingFunction: "linear",
          animationDirection: "normal",
          animationIterationCount: 1,
        }}
      />
      <clipPath id="eD90rl6Zy8e7">
        <rect width={284} height={33} fill="#fff" rx={0} ry={0} />
      </clipPath>
    </g>
  </svg>
          </div>
 }
          <div  className="title">
        <span className={currentColor.light? "black-text " : "light-text customize-shadow"}>Academy </span>
        <span className={currentColor.light? "red" : "red customize-shadow"}>Courses </span>

          </div>    
           </div>

          <div className="main-courses">
         <Svg10
                   style={!currentColor.light ? { filter: `drop-shadow(2px 4px 6px black)` } : {}}

         />

         <div className="text"> 
          <CircleBackground />
<div 
 key="5"
 data-id="5"
 ref={(el) => (elementsRef.current[5] = el)}  
          className={currentColor.light?"college" : "college customize-shadow"} 
         >

            {/* <div 

className={`${
 visibleElements[8]?"handWritting-appear handWritting" : " handWritting-disappear handWritting"
} ${currentColor.light ? "" : "customize-shadow"}`}
            >
            <Heart/>
            </div> */}
            <div   
           className={visibleElements[8]?"date-appear date" : " date-disappear date"}> 
          Sep 2021 – December 2022</div>
            <div 
            className={visibleElements[8]?"line-appear line" : " line-disappear line"}>

            </div>
            <div className="pic-details">
            <div className="details">
            <div
                className={`${
                  visibleElements[8]?"degree-appear degree" : "degree degree-disappear"
                } ${currentColor.light ? "red" : "dark-yellow "}`}>
Diploma of Computer Programming

</div>

<div
 className={`${
 visibleElements[8]?"location-appear" : " location-disappear"
} ${currentColor.light ? "black-text location " : "light-text location"}`}
 > 
<img
className={ visibleElements[8]? "location-img img-bounce " : "location-img location-img-disappear"}
  src={require("../src/pics/map.png")}
  alt=""
/>
Seneca College, Toronto, Canada
</div>

            <div className="points">
              <div className="point-image">

            <img
            className={visibleElements[8]?"point-image-appear-1 point-img" : " point-image-disappear point-img"}
            src={require("../src/pics/point.png")}
            alt=""
            />
            <span 
             className={`${
              visibleElements[8]? "text-point-appear-1 " : "text-point-disappear"
            } ${currentColor.light ? "black-text point " : "light-text point"}`}
             > 
             GPA: 4.0 across all semesters
              </span>
            </div>
            <div className="point-image">

<img
className={visibleElements[8]?"point-image-appear-2 point-img" : " point-image-disappear point-img"}
src={require("../src/pics/point.png")}
alt=""
/>
<span 
 className={`${
  visibleElements[8]? "text-point-appear-2 " : "text-point-disappear"
} ${currentColor.light ? "black-text point " : "light-text point"}`}
 > 
A+ in all Web Design courses</span>
</div>

<div className="point-image">

<img
className={visibleElements[8]?"point-image-appear-3 point-img" : " point-image-disappear point-img"}
src={require("../src/pics/point.png")}
alt=""
/>
<span 
 key="8"
 data-id="8"
 ref={(el) => (elementsRef.current[8] = el)} 
 className={`${
  visibleElements[8]? "text-point-appear-3 " : "text-point-disappear"
} ${currentColor.light ? "black-text point " : "light-text point"}`}
 > 
  A in Fundamental Programming courses</span>
</div>



         </div>
            </div>
            <img
            className={visibleElements[8]?"flag-img flag-scale-appear " : "flag-img flag-disappear"}
  src={require("../src/pics/canada.jpg")}
  alt=""
/>
            </div>


          </div>



<br></br>
          <div
         className={currentColor.light?"college" : "college customize-shadow"} 
         >
{/* 
            <div 

className={`${
 visibleElements[7]?"handWritting-appear handWritting" : " handWritting-disappear handWritting"
} ${currentColor.light ? "" : "customize-shadow"}`}
            >
            <Heart/>
            </div> */}
            <div   
           className={visibleElements[7]?"date-appear date" : " date-disappear date"}> 
          Sep 2014 – December 2018</div>
            <div 
            className={visibleElements[7]?"line-appear line" : " line-disappear line"}>

            </div>
            <div className="pic-details">
            <div className="details">
            <div
                className={`${
                  visibleElements[7]?"degree-appear degree" : "degree degree-disappear"
                } ${currentColor.light ? "red" : "dark-yellow "}`}>
Bachelor's Degree in Software Engineering
</div>

<div
 className={`${
 visibleElements[7]?"location-appear" : " location-disappear"
} ${currentColor.light ? "black-text location " : "light-text location"}`}
 > 
<img
className={ visibleElements[7]? "location-img img-bounce " : "location-img location-img-disappear"}
  src={require("../src/pics/map.png")}
  alt=""
/>
Ferdowsi University, Mashad, Iran
</div>

            <div className="points">
              <div className="point-image">

            <img
            className={visibleElements[7]?"point-image-appear-1 point-img" : " point-image-disappear point-img"}
            src={require("../src/pics/point.png")}
            alt=""
            />
            <span 
             className={`${
              visibleElements[7]? "text-point-appear-1 " : "text-point-disappear"
            } ${currentColor.light ? "black-text point " : "light-text point"}`}
             > 
            GPA: 4.0 across all semesters
              </span>
            </div>
            <div className="point-image">

<img
className={visibleElements[7]?"point-image-appear-2 point-img" : " point-image-disappear point-img"}
src={require("../src/pics/point.png")}
alt=""
/>
<span 
 className={`${
  visibleElements[7]? "text-point-appear-2 " : "text-point-disappear"
} ${currentColor.light ? "black-text point " : "light-text point"}`}
 > 
A+ in Database Design
  </span>
</div>

<div className="point-image">

<img
className={visibleElements[7]?"point-image-appear-3 point-img" : " point-image-disappear point-img"}
src={require("../src/pics/point.png")}
alt=""
/>
<span 
 key="7"
 data-id="7"
 ref={(el) => (elementsRef.current[7] = el)} 
 className={`${
  visibleElements[7]? "text-point-appear-3 " : "text-point-disappear"
} ${currentColor.light ? "black-text point " : "light-text point"}`}
 > 
  A+ in Software Architecture</span>
</div>

<div className="point-image">

<img
className={visibleElements[7]?"point-image-appear-4 point-img" : " point-image-disappear point-img"}
src={require("../src/pics/point.png")}
alt=""
/>
<span 
 key="7"
 data-id="7"
 ref={(el) => (elementsRef.current[7] = el)} 
 className={`${
  visibleElements[7]? "text-point-appear-4 " : "text-point-disappear"
} ${currentColor.light ? "black-text point " : "light-text point"}`}
 > 
 A+ in Distributed Systems</span>
</div>



         </div>
            </div>
            {/* <img
            className={visibleElements[7]?"flag-img flag-scale-appear " : "flag-img flag-disappear"}
  src={require("../src/pics/canada.jpg")}
  alt=""
/> */}
            </div>


          </div>
      
<br></br>




            </div>


          </div>
      </div>


<div className="container-out-courses">
      <div className="skills-title">

        <div
              className={currentColor.light?"img-title" : "img-title customize-shadow"} >

        {visibleElements[9] &&
        <svg
    xmlns="http://www.w3.org/2000/svg"
    id="ewsYahDFGuE1"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 56 61"
  >
    <style>
      {
        "@keyframes ewsYahDFGuE2_s_do{0%{stroke-dashoffset:142.87}25%,to{stroke-dashoffset:0}}@keyframes ewsYahDFGuE3_s_do{0%,60%{stroke-dashoffset:56.07}70%,to{stroke-dashoffset:0}}@keyframes ewsYahDFGuE3_s_da{0%,60%,to{stroke-dasharray:56.07}}@keyframes ewsYahDFGuE4_s_do{0%,50%{stroke-dashoffset:33.59}60%,to{stroke-dashoffset:0}}@keyframes ewsYahDFGuE4_s_da{0%,50%,to{stroke-dasharray:33.59}}@keyframes ewsYahDFGuE5_s_do{0%,25%{stroke-dashoffset:38.11}35%,to{stroke-dashoffset:0}}@keyframes ewsYahDFGuE5_s_da{0%,25%,to{stroke-dasharray:38.11}}@keyframes ewsYahDFGuE6_s_do{0%,40%{stroke-dashoffset:117.29}50%,to{stroke-dashoffset:0}}@keyframes ewsYahDFGuE6_s_da{0%,40%,to{stroke-dasharray:117.29}}@keyframes ewsYahDFGuE7_s_do{0%,70%{stroke-dashoffset:19.39}85%,to{stroke-dashoffset:0}}@keyframes ewsYahDFGuE7_s_da{0%,70%,to{stroke-dasharray:19.39}}@keyframes ewsYahDFGuE8_s_do{0%,90%{stroke-dashoffset:23.14}to{stroke-dashoffset:0}}@keyframes ewsYahDFGuE8_s_da{0%,90%,to{stroke-dasharray:23.14}}"
      }
    </style>
    <path
      fill="none"
      stroke="#f55"
      strokeDasharray={142.87}
      strokeDashoffset={142.87}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.663}
      d="M22.983 9.455c-8.341 1.601-14.405 4.01-19.692 10.806-3.35 4.308-2.615 11.088-.42 15.654 3.618 7.524 12.51 11.773 20.532 12.142 9.346.43 22.338-2.316 24.254-13.463 1.027-5.975-4.681-11.624-7.354-16.524-2.175-3.986-5.449-9.36-10.026-11.046-1.868-.689-6.205-.45-7.564 1.41-.608.831-1.39 1.708-1.831 2.642-.359.756.026-1.925-.06-2.702"
      style={{
        animation: "ewsYahDFGuE2_s_do 2000ms linear 1 normal forwards",
      }}
    />
    <path
      fill="none"
      stroke="#f55"
      strokeDasharray={56.07}
      strokeDashoffset={56.07}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.663}
      d="M26.496 29.987c-2.25 1.157-5.903 1.923-3.932 4.457.45.578 1.09.546 1.636 0 .467-.466 2.82-2.917 1.08-3.497-3.544-1.181-2.248 5.892.286 2.762 1.36-1.681-.544-3.336-2.252-2.311-2.034 1.22-.425 3.351 1.171 1.5 1.202-1.394.242-2.463-1.066-1.155-1.171 1.171.019 3.04 1.171 1.456 1.182-1.625-.166-3.001-1.59-1.576-1.65 1.65.135 1.476 1.305.39 1.18-1.095-.912-.933-1.59-.075-1.578 1.994.892 1.71 1.29 0 .584-2.513-2.008 3.26-.75-1.14"
      style={{
        animationName: "ewsYahDFGuE3_s_do,ewsYahDFGuE3_s_da",
        animationDuration: "2000ms",
        animationFillMode: "forwards",
        animationTimingFunction: "linear",
        animationDirection: "normal",
        animationIterationCount: 1,
      }}
    />
    <path
      fill="none"
      stroke="#f55"
      strokeDasharray={33.59}
      strokeDashoffset={33.59}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.663}
      d="M17.309 21.612c2.4 3.167 4.859 6.17 6.874 9.336.558.877.112 1.758.42 1.74 1.137-.063 2.3-.27 3.512-.27 2.77 0 4.953-1.35 7.624-1.35 3.234 0 7.986-.84 2.642-3.512"
      style={{
        animationName: "ewsYahDFGuE4_s_do,ewsYahDFGuE4_s_da",
        animationDuration: "2000ms",
        animationFillMode: "forwards",
        animationTimingFunction: "linear",
        animationDirection: "normal",
        animationIterationCount: 1,
      }}
    />
    <path
      fill="none"
      stroke="#f55"
      strokeDasharray={38.11}
      strokeDashoffset={38.11}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.663}
      d="M14.61 9.185c-.504-2.554-2.97-8.746 1.621-8.09 1.648.236 2.753 1.94 3.722 3.017 2.522 2.802 2.252 6.183-1.83 6.424-1.07.063-2.576 2.183-3.783.675-1.366-1.708.029-1.593.27-3.647.158-1.344-.719-1.232-1.096-2.552-.289-1.011.312-2.12.556-2.851"
      style={{
        animationName: "ewsYahDFGuE5_s_do,ewsYahDFGuE5_s_da",
        animationDuration: "2000ms",
        animationFillMode: "forwards",
        animationTimingFunction: "linear",
        animationDirection: "normal",
        animationIterationCount: 1,
      }}
    />
    <path
      fill="none"
      stroke="#f55"
      strokeDasharray={117.29}
      strokeDashoffset={117.29}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.663}
      d="M16.226 6.213c-.024.646-1.019 6.46 1.096 5.508.708-.318 1.32-.781 1.606-1.515.277-.712-.018-1.136-.33-1.831-.806-1.79-3.144-4.574-2.432-.54.45 2.544 3.291 1.95 3.512-.481.169-1.856-2.171-4.342-3.662-2.221-1.054 1.5.823 4.809 1.921 2.491.557-1.177-.775-4.168-2.191-2.701-1.452 1.503.73 4.675 2.161 3.392 1.415-1.27.453-5.14-1.08-3.663-1.404 1.352.702 4.04 1.77 1.982 1.193-2.297-1.434-4.027-2.25-1.621-.73 2.147 1.544 4.457 2.07 1.53.4-2.227-3.692-3.412-3.692-.75 0 2.452 2.192 2.201 2.192-.03 0-2.325-2.342-1.802-1.366.15s2.284-1.512 1.186-2.611c-1.283-1.283-2.982.7-1.471 1.936 1.029.842 2.437-2.653.705-3.302-1.495-.56-.668 2.492-.15 1.8.803-1.07-.428-1.787.42-1.575.748.187 2.564.586 3.077 1.246.404.519 2.041 3.407 2.041 4.157 0 2.295-3.51 3.532-5.523 2.957-1.445-.413-1.873.608-1.366.27 1.23-.82 1.486-2.957 1.486-2.146"
      style={{
        animationName: "ewsYahDFGuE6_s_do,ewsYahDFGuE6_s_da",
        animationDuration: "2000ms",
        animationFillMode: "forwards",
        animationTimingFunction: "linear",
        animationDirection: "normal",
        animationIterationCount: 1,
      }}
    />
    <path
      fill="none"
      stroke="#f55"
      strokeDasharray={19.39}
      strokeDashoffset={19.39}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.663}
      d="M15.959 47.817c-1.391 2.952-2.626 5.917-4.262 8.705-.37.628-1.06 1.91-1.141 2.642-.22 1.97 1.76-4.7 2.161-5.673"
      style={{
        animationName: "ewsYahDFGuE7_s_do,ewsYahDFGuE7_s_da",
        animationDuration: "2000ms",
        animationFillMode: "forwards",
        animationTimingFunction: "linear",
        animationDirection: "normal",
        animationIterationCount: 1,
      }}
    />
    <path
      fill="none"
      stroke="#f55"
      strokeDasharray={23.14}
      strokeDashoffset={23.14}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.663}
      d="M43.246 42.144c3.421 4.32 7.194 7.401 9.86 12.142.263.467.719.838 1.081 1.2 1.214 1.214-2.252-2.59-3.377-3.887"
      style={{
        animationName: "ewsYahDFGuE8_s_do,ewsYahDFGuE8_s_da",
        animationDuration: "2000ms",
        animationFillMode: "forwards",
        animationTimingFunction: "linear",
        animationDirection: "normal",
        animationIterationCount: 1,
      }}
    />
  </svg>
        }
        </div>
          <div className="title">
        <span className={currentColor.light? "black-text " : "light-text customize-shadow"}>Out Of  </span>
        <span className={currentColor.light? "red" : "red customize-shadow"}>Univesity Courses </span>

          </div>  
          </div>
          <div className="whole">
          <div
        className={currentColor.light? "text" : "text customize-shadow"}>
          <CircleBackground />

            <div
             className={`${
              visibleElements[9]? "title-appear-1 " : "title-disappear"
            } ${currentColor.light ? "black-text title " : "yellow title"}`}>
              
              Web Development Bootcamp</div>
            <span 
                         className={`${
                          visibleElements[9]? "description-appear-1 " : "description-disappear"
                        } ${currentColor.light ? "black-text description " : "light-text description"}`}>

Completed a 4-month intensive program focusing on front-end and back-end development. Gained hands-on experience with HTML, CSS, JavaScript, React, Node.js, and databases. Built and deployed full-stack projects with responsive design and efficient APIs.            </span>
<br></br>
<div
className={`${
              visibleElements[9]? "title-appear-2 " : "title-disappear"
            } ${currentColor.light ? "green title " : "green title"}`}>
  Solve 500 questions in leetCode
  </div>
<span
           className={`${
            visibleElements[9]? "description-appear-2 " : "description-disappear"
          } ${currentColor.light ? "black-text description " : "light-text description"}`}>

Solved 500 questions on LeetCode, strengthening my skills in data structures, algorithms, and problem-solving techniques. Gained expertise in key topics such as arrays, linked lists, binary trees, dynamic programming, graph traversal, sorting and searching, and backtracking.</span>
<div 
className={`${
              visibleElements[9]? "title-appear-3 " : "title-disappear"
            } ${currentColor.light ? "black-text title " : "yellow title"}`}>
  
  Pass more than 10 online courses</div>
<span
 key="9"
 data-id="9"
 ref={(el) => (elementsRef.current[9] = el)} 
 className={`${
  visibleElements[9]? "description-appear-3 " : "description-disappear"
} ${currentColor.light ? "black-text description " : "light-text description"}`}>
Completed over 10 online courses on platforms like Udemy and Code with Mosh. Gained in-depth knowledge of web development, JavaScript frameworks, and backend technologies. Enhanced my skills in building scalable applications and mastering industry-standard tools.</span>
          </div>
          
      <div className="skills">
      <img  className={visibleElements[9]? "show-img-1 " : "disappear-img"} src={require("./pics/leetcode.png")} alt="react"  />
      <img className={visibleElements[9]? "show-img-2 " : "disappear-img"}  src={require("./pics/udemy.png")} alt="html"  />
      <img className={visibleElements[9]? "show-img-3 " : "disappear-img"}  src={require("./pics/mosh.png")} alt="react"  />

      </div>
      </div>
      </div>

      <div id='experinces' ref={experincesRef} className="container-experience">
      <div className="title-experience">
      <div className="background">
      <Svg102/>

      </div>
      <span className={currentColor.light? "black-text " : "light-text customize-shadow "}>My  </span>
      <span
      className={currentColor.light? "red" : "red customize-shadow"}>
        Experiences </span>   

             </div>
          <div className="main-experince">
            <div
                  className={currentColor.light? "text" : "text customize-shadow"}>
            <CircleBackground />

              <div 
               key="10"
               data-id="10"
               ref={(el) => (elementsRef.current[10] = el)} 
              className="job">
                <div className="top">
<div className="details">
              <div className={visibleElements[10]?"date-appear date" : " date-disappear date"}> Jan 2025 – Present 

              <span 
              className={currentColor.light? "red part-time" : "dark-yellow part-time"}
              
              >Full Time</span>

              </div>
              <div className={visibleElements[10]?"job-title-appear2 job-title blue" : " job-title-disappear job-title blue"} > Develop & Conquer Company 
 
              </div>
              <div className={visibleElements[10]?"job-title-appear job-title" : " job-title-disappear job-title"} > Full-Stack Developer (Intern)</div>
              </div>
              <div className="img">
              <img
            className={visibleElements[10]?"flag-img flag-scale-appear2 " : "flag-img flag-disappear"}
  src={require("../src/pics/canada.jpg")}
  alt=""
/>
</div>
              </div>
              <div className={currentColor.light? "black-text descriptions" : "light-text descriptions"}>
            
                <div className="des">
                <img
className={visibleElements[10]?"point-image-appear-1 point-img" : " point-image-disappear point-img"}
src={require("../src/pics/point-2.png")}
                alt=""
              />
                 <span  className={`${
  visibleElements[10]? "text-point-appear-1 " : "text-point-disappear"
} ${currentColor.light ? "black-text point " : "light-text point"}`}>
Built and maintained a patient and payment platform with Django and PostgreSQL.
                  </span> 
                  </div>

                  <div className="des">
                <img
className={visibleElements[10]?"point-image-appear-2 point-img" : " point-image-disappear point-img"}
src={require("../src/pics/point-2.png")}
                alt=""
              />
                 <span  className={`${
  visibleElements[10]? "text-point-appear-2 " : "text-point-disappear"
} ${currentColor.light ? "black-text point " : "light-text point"}`}>
Designed an automated appointment system using Stripe, Twilio, and SendGrid.
</span> 
                  </div>

                  <div className="des">
                <img
className={visibleElements[10]?"point-image-appear-3 point-img" : " point-image-disappear point-img"}
src={require("../src/pics/point-2.png")}
                alt=""
              />
                 <span  className={`${
  visibleElements[10]? "text-point-appear-3 " : "text-point-disappear"
} ${currentColor.light ? "black-text point " : "light-text point"}`}>
Secured authentication with JWT and OAuth for clinics and patients.                 </span> 
                  </div>

                  {/* <div className="des">
                <img
className={visibleElements[10]?"point-image-appear-4 point-img" : " point-image-disappear point-img"}
src={require("../src/pics/point-2.png")}
                alt=""
              />
                 <span  className={`${
  visibleElements[10]? "text-point-appear-4 " : "text-point-disappear"
} ${currentColor.light ? "black-text point " : "light-text point"}`}>
                Deployed and maintained applications on cloud platforms. </span> 
                  </div> */}

              
              </div>
              <div className="tags">
                <span
                 className={`${
                  visibleElements[10]? "tag-appear-1 " : "tag-disappear"
                } ${currentColor.light ? "tag tag-light " : "tag tag-dark"}`}
                >
                  Django</span>
                <span
   className={`${
    visibleElements[10]? "tag-appear-2 " : "tag-disappear"
  } ${currentColor.light ? "tag tag-light " : "tag tag-dark"}`}                 >Node JS</span>
                <span 
   className={`${
    visibleElements[10]? "tag-appear-3 " : "tag-disappear"
  } ${currentColor.light ? "tag tag-light " : "tag tag-dark"}`}                >React</span>
                <span 
   className={`${
    visibleElements[10]? "tag-appear-4 " : "tag-disappear"
  } ${currentColor.light ? "tag tag-light " : "tag tag-dark"}`}                >Mongo DB</span>
                <span
   className={`${
    visibleElements[10]? "tag-appear-5 " : "tag-disappear"
  } ${currentColor.light ? "tag tag-light " : "tag tag-dark"}`}                >SQL</span>

<span
   className={`${
    visibleElements[10]? "tag-appear-5 " : "tag-disappear"
  } ${currentColor.light ? "tag tag-light " : "tag tag-dark"}`}                >Express.js</span>

<span
   className={`${
    visibleElements[10]? "tag-appear-5 " : "tag-disappear"
  } ${currentColor.light ? "tag tag-light " : "tag tag-dark"}`}                >API Development</span>
                </div>
              </div>
<br></br>
<br></br>

<div 
               key="11"
               data-id="11"
               ref={(el) => (elementsRef.current[11] = el)} 
              className="job">
              <div className="top">
              <div className="details">
              <div className={visibleElements[11]?"date-appear date" : " date-disappear date"}> Sep 2023 – Dec 2024 
              <span 
              
              className={currentColor.light? "red part-time" : "dark-yellow part-time"}
              >Full Time</span>
              </div>
              <div className={visibleElements[11]?"job-title-appear2 job-title blue" : " job-title-disappear job-title blue"} > Setareh tech Company </div>

              <div className={visibleElements[11]?"job-title-appear job-title" : " job-title-disappear job-title"} > Full-Stack Developer </div>
             
              </div>
              </div>
              <div className={currentColor.light? "black-text descriptions" : "light-text descriptions"}>

                <div className="des">
                <img
className={visibleElements[11]?"point-image-appear-1 point-img" : " point-image-disappear point-img"}
src={require("../src/pics/point-2.png")}
                alt=""
              />
                 <span  className={`${
  visibleElements[11]? "text-point-appear-1 " : "text-point-disappear"
} ${currentColor.light ? "black-text point " : "light-text point"}`}>
Built a classified ads platform using Node.js, MongoDB.          </span> 
                  </div>

                  <div className="des">
                <img
className={visibleElements[11]?"point-image-appear-2 point-img" : " point-image-disappear point-img"}
src={require("../src/pics/point-2.png")}
                alt=""
              />
                 <span  className={`${
  visibleElements[11]? "text-point-appear-2 " : "text-point-disappear"
} ${currentColor.light ? "black-text point " : "light-text point"}`}>
Developed a real-time chat system with WebSocket and Redis caching.                  </span> 
                  </div>

                  <div className="des">
                <img
className={visibleElements[11]?"point-image-appear-3 point-img" : " point-image-disappear point-img"}
src={require("../src/pics/point-2.png")}
                alt=""
              />
                 <span  className={`${
  visibleElements[11]? "text-point-appear-3 " : "text-point-disappear"
} ${currentColor.light ? "black-text point " : "light-text point"}`}>
Optimized UI performance in React.js and Angular.







</span> 
                  </div>

                  {/* <div className="des">
                <img
className={visibleElements[11]?"point-image-appear-4 point-img" : " point-image-disappear point-img"}
src={require("../src/pics/point-2.png")}
                alt=""
              />
                 <span  className={`${
  visibleElements[11]? "text-point-appear-4 " : "text-point-disappear"
} ${currentColor.light ? "black-text point " : "light-text point"}`}>
                Optimized performance and improved front-end efficiency.
                  </span> 
                  </div> */}

              
              </div>
              <div className="tags">
                <span
                 className={`${
                  visibleElements[11]? "tag-appear-1 " : "tag-disappear"
                } ${currentColor.light ? "tag tag-light " : "tag tag-dark"}`}
                >
                  Node JS
                  </span>
                <span
   className={`${
    visibleElements[11]? "tag-appear-2 " : "tag-disappear"
  } ${currentColor.light ? "tag tag-light " : "tag tag-dark"}`}                 >React</span>
                <span 
   className={`${
    visibleElements[11]? "tag-appear-3 " : "tag-disappear"
  } ${currentColor.light ? "tag tag-light " : "tag tag-dark"}`}                >Angular</span>
                <span 
   className={`${
    visibleElements[11]? "tag-appear-4 " : "tag-disappear"
  } ${currentColor.light ? "tag tag-light " : "tag tag-dark"}`}                >Mongo DB
</span>
                <span
   className={`${
    visibleElements[11]? "tag-appear-5 " : "tag-disappear"
  } ${currentColor.light ? "tag tag-light " : "tag tag-dark"}`} 
  >SQL </span>

<span
   className={`${
    visibleElements[11]? "tag-appear-6 " : "tag-disappear"
  } ${currentColor.light ? "tag tag-light " : "tag tag-dark"}`} 
  >API Development
</span>

                </div>
              </div>


            </div>
         <Svg5/>


          </div>
      </div>


      <div className="footer"></div>
      </Fragment>
    )
  }
    
